{
  "schema": {
    "import": [
      {
        "_namespace": "http://www.opengis.net/gml/3.2",
        "_schemaLocation": "http://schemas.opengis.net/gml/3.2.1/gml.xsd"
      },
      {
        "_namespace": "http://www.w3.org/1999/xlink",
        "_schemaLocation": "http://www.w3.org/1999/xlink.xsd"
      }
    ],
    "annotation": {
      "appinfo": {
        "gmlProfileSchema": {
          "__prefix": "gml",
          "__text": "http://external.schemas.opengis.net/gmlAIXMProfile/1.1/gml321forAIXM.xsd"
        }
      }
    },
    "include": [
      {
        "_schemaLocation": "./AIXM_DataTypes.xsd"
      },
      {
        "_schemaLocation": "./AIXM_AbstractGML_ObjectTypes.xsd"
      }
    ],
    "complexType": [
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AerialRefuellingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AerialRefuellingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AerialRefuellingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AerialRefuellingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AerialRefuellingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AerialRefuellingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAerialRefuellingExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AerialRefuellingTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AerialRefuellingAnchorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAerialRefuellingAnchorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AerialRefuellingAnchorType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AerialRefuellingAnchor"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AerialRefuellingAnchorPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SegmentPointPropertyGroup"
                },
                {
                  "_ref": "aixm:AerialRefuellingPointPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSegmentPointExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAerialRefuellingPointExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSegmentPointType"
          }
        },
        "_name": "AerialRefuellingPointType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AerialRefuellingPoint"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AerialRefuellingPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AerialRefuellingTrackPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAerialRefuellingTrackExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AerialRefuellingTrackType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AerialRefuellingTrack"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AerialRefuellingTrackPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AuthorityForAerialRefuellingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAuthorityForAerialRefuellingExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AuthorityForAerialRefuellingType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AuthorityForAerialRefuelling"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AuthorityForAerialRefuellingPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportHeliportPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirportHeliportTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AirportHeliportType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirportHeliportTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirportHeliportTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirportHeliportPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAirportHeliportExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirportHeliportTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:AirportHeliportAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportHeliportAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "AirportHeliportAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirportHeliportAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirportHeliportAvailabilityPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportHeliportCollocationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirportHeliportCollocationTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AirportHeliportCollocationType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirportHeliportCollocationTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirportHeliportCollocationTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirportHeliportCollocationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAirportHeliportCollocationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirportHeliportCollocationTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportHeliportProtectionAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractAirportHeliportProtectionAreaType",
        "_abstract": "true"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:AirportHeliportResponsibilityOrganisationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportHeliportResponsibilityOrganisationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "AirportHeliportResponsibilityOrganisationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirportHeliportResponsibilityOrganisation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirportHeliportResponsibilityOrganisationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:UsageConditionPropertyGroup"
                },
                {
                  "_ref": "aixm:AirportHeliportUsagePropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractUsageConditionExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportHeliportUsageExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractUsageConditionType"
          }
        },
        "_name": "AirportHeliportUsageType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirportHeliportUsage"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirportHeliportUsagePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportHotSpotPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirportHotSpotTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AirportHotSpotType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirportHotSpotTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirportHotSpotTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirportHotSpotPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAirportHotSpotExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirportHotSpotTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AltimeterSourcePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AltimeterSourceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AltimeterSourceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AltimeterSourceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AltimeterSourceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AltimeterSourcePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAltimeterSourceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AltimeterSourceTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:AltimeterSourceStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAltimeterSourceStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "AltimeterSourceStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AltimeterSourceStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AltimeterSourceStatusPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CityPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractCityExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "CityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:City"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "CityPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:ConditionCombinationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractConditionCombinationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "ConditionCombinationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ConditionCombination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ConditionCombinationPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NonMovementAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:NonMovementAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "NonMovementAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:NonMovementAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "NonMovementAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NonMovementAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractNonMovementAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "NonMovementAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SurfaceCharacteristicsPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractSurfaceCharacteristicsExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "SurfaceCharacteristicsType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:SurfaceCharacteristics"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SurfaceCharacteristicsPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SurveyControlPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SurveyControlPointTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SurveyControlPointType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SurveyControlPointTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SurveyControlPointTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SurveyControlPointPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSurveyControlPointExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SurveyControlPointTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": "",
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AbstractUsageConditionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AbstractUsageCondition"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "UsageConditionPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "WorkAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:WorkAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "WorkAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:WorkAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "WorkAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:WorkAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractWorkAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "WorkAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:WorkareaActivityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractWorkareaActivityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "WorkareaActivityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:WorkareaActivity"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "WorkareaActivityPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AircraftStandPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AircraftStandTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AircraftStandType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AircraftStandTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AircraftStandTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AircraftStandPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAircraftStandExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AircraftStandTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ApronPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ApronTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "ApronType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ApronTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ApronTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApronPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractApronExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ApronTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:ApronAreaAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApronAreaAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "ApronAreaAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApronAreaAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApronAreaAvailabilityPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:UsageConditionPropertyGroup"
                },
                {
                  "_ref": "aixm:ApronAreaUsagePropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractUsageConditionExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApronAreaUsageExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractUsageConditionType"
          }
        },
        "_name": "ApronAreaUsageType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApronAreaUsage"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApronAreaUsagePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ApronElementPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ApronElementTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "ApronElementType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ApronElementTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ApronElementTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApronElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractApronElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ApronElementTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DeicingAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DeicingAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "DeicingAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DeicingAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DeicingAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DeicingAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractDeicingAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DeicingAreaTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "PassengerLoadingBridgePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:PassengerLoadingBridgeTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "PassengerLoadingBridgeType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:PassengerLoadingBridgeTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "PassengerLoadingBridgeTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PassengerLoadingBridgePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractPassengerLoadingBridgeExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "PassengerLoadingBridgeTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RoadPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RoadTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RoadType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RoadTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RoadTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RoadPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRoadExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RoadTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TouchDownLiftOffPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TouchDownLiftOffTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "TouchDownLiftOffType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TouchDownLiftOffTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TouchDownLiftOffTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TouchDownLiftOffPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractTouchDownLiftOffExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TouchDownLiftOffTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TouchDownLiftOffSafeAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TouchDownLiftOffSafeAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportHeliportProtectionAreaType"
          }
        },
        "_name": "TouchDownLiftOffSafeAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TouchDownLiftOffSafeAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TouchDownLiftOffSafeAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TouchDownLiftOffSafeAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTouchDownLiftOffSafeAreaExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportHeliportProtectionAreaExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TouchDownLiftOffSafeAreaTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ApproachLightingSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ApproachLightingSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "ApproachLightingSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ApproachLightingSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ApproachLightingSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApproachLightingSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractApproachLightingSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ApproachLightingSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ApronLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ApronLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "ApronLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ApronLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ApronLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApronLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractApronLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ApronLightSystemTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:GroundLightingAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightingAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "GroundLightingAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:GroundLightingAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "GroundLightingAvailabilityPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GroundLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractGroundLightSystemType",
        "_abstract": "true"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GuidanceLineLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:GuidanceLineLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "GuidanceLineLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:GuidanceLineLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "GuidanceLineLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:GuidanceLineLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractGuidanceLineLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "GuidanceLineLightSystemTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:LightActivationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractLightActivationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "LightActivationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:LightActivation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "LightActivationPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayDirectionLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayDirectionLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "RunwayDirectionLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayDirectionLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayDirectionLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayDirectionLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractRunwayDirectionLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayDirectionLightSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayProtectAreaLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayProtectAreaLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "RunwayProtectAreaLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayProtectAreaLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayProtectAreaLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayProtectAreaLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractRunwayProtectAreaLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayProtectAreaLightSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiHoldingPositionLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiHoldingPositionLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "TaxiHoldingPositionLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiHoldingPositionLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiHoldingPositionLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiHoldingPositionLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTaxiHoldingPositionLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiHoldingPositionLightSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiwayLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiwayLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "TaxiwayLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiwayLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiwayLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiwayLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTaxiwayLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiwayLightSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TouchDownLiftOffLightSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TouchDownLiftOffLightSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "TouchDownLiftOffLightSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TouchDownLiftOffLightSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TouchDownLiftOffLightSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TouchDownLiftOffLightSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTouchDownLiftOffLightSystemExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TouchDownLiftOffLightSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportProtectionAreaMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirportProtectionAreaMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "AirportProtectionAreaMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirportProtectionAreaMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirportProtectionAreaMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirportProtectionAreaMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAirportProtectionAreaMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirportProtectionAreaMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ApronMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ApronMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "ApronMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ApronMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ApronMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApronMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractApronMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ApronMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DeicingAreaMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DeicingAreaMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "DeicingAreaMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DeicingAreaMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DeicingAreaMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DeicingAreaMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractDeicingAreaMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DeicingAreaMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GuidanceLineMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:GuidanceLineMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "GuidanceLineMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:GuidanceLineMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "GuidanceLineMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:GuidanceLineMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractGuidanceLineMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "GuidanceLineMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "MarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractMarkingType",
        "_abstract": "true"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MarkingElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractMarkingElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "MarkingElementType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:MarkingElement"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "MarkingElementPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "RunwayMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractRunwayMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "StandMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:StandMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "StandMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:StandMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "StandMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractStandMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "StandMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiHoldingPositionMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiHoldingPositionMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "TaxiHoldingPositionMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiHoldingPositionMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiHoldingPositionMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiHoldingPositionMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTaxiHoldingPositionMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiHoldingPositionMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiwayMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiwayMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "TaxiwayMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiwayMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiwayMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiwayMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTaxiwayMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiwayMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TouchDownLiftOffMarkingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TouchDownLiftOffMarkingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractMarkingType"
          }
        },
        "_name": "TouchDownLiftOffMarkingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TouchDownLiftOffMarkingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TouchDownLiftOffMarkingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TouchDownLiftOffMarkingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTouchDownLiftOffMarkingExtension"
                      },
                      {
                        "_ref": "aixm:AbstractMarkingExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TouchDownLiftOffMarkingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ArrestingGearPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ArrestingGearTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "ArrestingGearType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ArrestingGearTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ArrestingGearTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ArrestingGearPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractArrestingGearExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ArrestingGearTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:ManoeuvringAreaAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractManoeuvringAreaAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "ManoeuvringAreaAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ManoeuvringAreaAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ManoeuvringAreaAvailabilityPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:UsageConditionPropertyGroup"
                },
                {
                  "_ref": "aixm:ManoeuvringAreaUsagePropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractUsageConditionExtension"
                      },
                      {
                        "_ref": "aixm:AbstractManoeuvringAreaUsageExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractUsageConditionType"
          }
        },
        "_name": "ManoeuvringAreaUsageType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ManoeuvringAreaUsage"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ManoeuvringAreaUsagePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NavaidEquipmentDistancePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractNavaidEquipmentDistanceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "NavaidEquipmentDistanceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:NavaidEquipmentDistance"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NavaidEquipmentDistancePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RunwayType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayBlastPadPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayBlastPadTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RunwayBlastPadType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayBlastPadTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayBlastPadTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayBlastPadPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayBlastPadExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayBlastPadTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayCentrelinePointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayCentrelinePointTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RunwayCentrelinePointType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayCentrelinePointTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayCentrelinePointTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayCentrelinePointPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayCentrelinePointExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayCentrelinePointTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayDeclaredDistancePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayDeclaredDistanceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "RunwayDeclaredDistanceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RunwayDeclaredDistance"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RunwayDeclaredDistancePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:RunwayDeclaredDistanceValuePropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRunwayDeclaredDistanceValueExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "RunwayDeclaredDistanceValueType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RunwayDeclaredDistanceValue"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RunwayDeclaredDistanceValuePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayDirectionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayDirectionTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RunwayDirectionType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayDirectionTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayDirectionTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayDirectionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayDirectionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayDirectionTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayElementPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayElementTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RunwayElementType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayElementTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayElementTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayElementTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayProtectAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayProtectAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportHeliportProtectionAreaType"
          }
        },
        "_name": "RunwayProtectAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayProtectAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayProtectAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayProtectAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractRunwayProtectAreaExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportHeliportProtectionAreaExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayProtectAreaTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RunwayVisualRangePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RunwayVisualRangeTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RunwayVisualRangeType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RunwayVisualRangeTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RunwayVisualRangeTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RunwayVisualRangePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRunwayVisualRangeExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RunwayVisualRangeTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "VisualGlideSlopeIndicatorPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:VisualGlideSlopeIndicatorTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractGroundLightSystemType"
          }
        },
        "_name": "VisualGlideSlopeIndicatorType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:VisualGlideSlopeIndicatorTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "VisualGlideSlopeIndicatorTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:VisualGlideSlopeIndicatorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractVisualGlideSlopeIndicatorExtension"
                      },
                      {
                        "_ref": "aixm:AbstractGroundLightSystemExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "VisualGlideSlopeIndicatorTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "FloatingDockSitePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:FloatingDockSiteTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "FloatingDockSiteType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:FloatingDockSiteTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "FloatingDockSiteTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FloatingDockSitePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractFloatingDockSiteExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "FloatingDockSiteTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "MarkingBuoyPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:MarkingBuoyTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "MarkingBuoyType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:MarkingBuoyTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "MarkingBuoyTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MarkingBuoyPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractMarkingBuoyExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "MarkingBuoyTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SeaplaneLandingAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SeaplaneLandingAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SeaplaneLandingAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SeaplaneLandingAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SeaplaneLandingAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SeaplaneLandingAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSeaplaneLandingAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SeaplaneLandingAreaTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SeaplaneRampSitePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SeaplaneRampSiteTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SeaplaneRampSiteType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SeaplaneRampSiteTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SeaplaneRampSiteTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SeaplaneRampSitePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSeaplaneRampSiteExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SeaplaneRampSiteTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:AircraftStandContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAircraftStandContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "AircraftStandContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AircraftStandContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AircraftStandContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:AirportHeliportContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportHeliportContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "AirportHeliportContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirportHeliportContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirportHeliportContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:ApronContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApronContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "ApronContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApronContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApronContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RidgePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractRidgeExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "RidgeType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Ridge"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RidgePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:RunwayContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRunwayContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "RunwayContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RunwayContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RunwayContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:RunwaySectionContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRunwaySectionContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "RunwaySectionContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RunwaySectionContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RunwaySectionContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": "",
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AbstractSurfaceContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AbstractSurfaceContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SurfaceContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SurfaceContaminationLayerPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractSurfaceContaminationLayerExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "SurfaceContaminationLayerType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:SurfaceContaminationLayer"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SurfaceContaminationLayerPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:TaxiwayContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractTaxiwayContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "TaxiwayContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:TaxiwayContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "TaxiwayContaminationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SurfaceContaminationPropertyGroup"
                },
                {
                  "_ref": "aixm:TouchDownLiftOffContaminationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSurfaceContaminationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractTouchDownLiftOffContaminationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurfaceContaminationType"
          }
        },
        "_name": "TouchDownLiftOffContaminationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:TouchDownLiftOffContamination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "TouchDownLiftOffContaminationPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GuidanceLinePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:GuidanceLineTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "GuidanceLineType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:GuidanceLineTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "GuidanceLineTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:GuidanceLinePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractGuidanceLineExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "GuidanceLineTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiHoldingPositionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiHoldingPositionTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "TaxiHoldingPositionType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiHoldingPositionTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiHoldingPositionTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiHoldingPositionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractTaxiHoldingPositionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiHoldingPositionTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiwayPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiwayTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "TaxiwayType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiwayTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiwayTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiwayPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractTaxiwayExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiwayTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TaxiwayElementPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TaxiwayElementTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "TaxiwayElementType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TaxiwayElementTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TaxiwayElementTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TaxiwayElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractTaxiwayElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TaxiwayElementTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirspacePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirspaceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AirspaceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirspaceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirspaceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirspacePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAirspaceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirspaceTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:AirspaceActivationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirspaceActivationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "AirspaceActivationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirspaceActivation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirspaceActivationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirspaceGeometryComponentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAirspaceGeometryComponentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AirspaceGeometryComponentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirspaceGeometryComponent"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirspaceGeometryComponentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:AirspaceLayerClassPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirspaceLayerClassExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "AirspaceLayerClassType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirspaceLayerClass"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirspaceLayerClassPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirspaceVolumePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAirspaceVolumeExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AirspaceVolumeType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirspaceVolume"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirspaceVolumePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirspaceVolumeDependencyPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAirspaceVolumeDependencyExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AirspaceVolumeDependencyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirspaceVolumeDependency"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirspaceVolumeDependencyPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AuthorityForAirspacePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AuthorityForAirspaceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AuthorityForAirspaceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AuthorityForAirspaceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AuthorityForAirspaceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AuthorityForAirspacePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAuthorityForAirspaceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AuthorityForAirspaceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GeoBorderPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:GeoBorderTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "GeoBorderType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:GeoBorderTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "GeoBorderTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:GeoBorderPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractGeoBorderExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "GeoBorderTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CurvePropertyGroup"
              }
            },
            "_base": "gml:CurveType"
          }
        },
        "_name": "CurveType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Curve"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "CurvePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ElevatedCurvePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractElevatedCurveExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:CurveType"
          }
        },
        "_name": "ElevatedCurveType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ElevatedCurve"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ElevatedCurvePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ElevatedPointPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractElevatedPointExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:PointType"
          }
        },
        "_name": "ElevatedPointType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ElevatedPoint"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ElevatedPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ElevatedSurfacePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractElevatedSurfaceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:SurfaceType"
          }
        },
        "_name": "ElevatedSurfaceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ElevatedSurface"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ElevatedSurfacePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PointPropertyGroup"
              }
            },
            "_base": "gml:PointType"
          }
        },
        "_name": "PointType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Point"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "PointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SurfacePropertyGroup"
              }
            },
            "_base": "gml:SurfaceType"
          }
        },
        "_name": "SurfaceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Surface"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SurfacePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "HoldingPatternPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:HoldingPatternTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "HoldingPatternType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:HoldingPatternTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "HoldingPatternTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:HoldingPatternPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractHoldingPatternExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "HoldingPatternTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:HoldingPatternDistancePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractHoldingPatternDistanceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "HoldingPatternDistanceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:HoldingPatternDistance"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "HoldingPatternDistancePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:HoldingPatternDurationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractHoldingPatternDurationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "HoldingPatternDurationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:HoldingPatternDuration"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "HoldingPatternDurationPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "UnplannedHoldingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:UnplannedHoldingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "UnplannedHoldingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:UnplannedHoldingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "UnplannedHoldingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:UnplannedHoldingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractUnplannedHoldingExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "UnplannedHoldingTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AuthorityForNavaidEquipmentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAuthorityForNavaidEquipmentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AuthorityForNavaidEquipmentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AuthorityForNavaidEquipment"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AuthorityForNavaidEquipmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AuthorityForSpecialNavigationStationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAuthorityForSpecialNavigationStationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AuthorityForSpecialNavigationStationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AuthorityForSpecialNavigationStation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AuthorityForSpecialNavigationStationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AuthorityForSpecialNavigationSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAuthorityForSpecialNavigationSystemExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AuthorityForSpecialNavigationSystemType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AuthorityForSpecialNavigationSystem"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AuthorityForSpecialNavigationSystemPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AzimuthPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AzimuthTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "AzimuthType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AzimuthTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AzimuthTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AzimuthPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAzimuthExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AzimuthTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "CheckpointINSPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:CheckpointINSTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavigationSystemCheckpointType"
          }
        },
        "_name": "CheckpointINSType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:CheckpointINSTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "CheckpointINSTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CheckpointINSPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractCheckpointINSExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavigationSystemCheckpointExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "CheckpointINSTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "CheckpointVORPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:CheckpointVORTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavigationSystemCheckpointType"
          }
        },
        "_name": "CheckpointVORType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:CheckpointVORTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "CheckpointVORTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CheckpointVORPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractCheckpointVORExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavigationSystemCheckpointExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "CheckpointVORTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DirectionFinderPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DirectionFinderTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "DirectionFinderType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DirectionFinderTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DirectionFinderTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DirectionFinderPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractDirectionFinderExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DirectionFinderTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DMEPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DMETimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "DMEType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DMETimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DMETimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DMEPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractDMEExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DMETimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ElevationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ElevationTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "ElevationType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ElevationTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ElevationTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ElevationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractElevationExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ElevationTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GlidepathPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:GlidepathTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "GlidepathType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:GlidepathTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "GlidepathTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:GlidepathPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractGlidepathExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "GlidepathTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "LocalizerPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:LocalizerTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "LocalizerType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:LocalizerTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "LocalizerTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:LocalizerPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractLocalizerExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "LocalizerTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "MarkerBeaconPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:MarkerBeaconTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "MarkerBeaconType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:MarkerBeaconTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "MarkerBeaconTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MarkerBeaconPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractMarkerBeaconExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "MarkerBeaconTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NavaidPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:NavaidTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "NavaidType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:NavaidTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "NavaidTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NavaidPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractNavaidExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "NavaidTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NavaidComponentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractNavaidComponentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "NavaidComponentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:NavaidComponent"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NavaidComponentPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NavaidEquipmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractNavaidEquipmentType",
        "_abstract": "true"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:NavaidEquipmentMonitoringPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentMonitoringExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "NavaidEquipmentMonitoringType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:NavaidEquipmentMonitoring"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NavaidEquipmentMonitoringPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:NavaidOperationalStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidOperationalStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "NavaidOperationalStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:NavaidOperationalStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NavaidOperationalStatusPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NavigationSystemCheckpointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractNavigationSystemCheckpointType",
        "_abstract": "true"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NDBPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:NDBTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "NDBType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:NDBTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "NDBTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NDBPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractNDBExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "NDBTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SDFPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SDFTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "SDFType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SDFTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SDFTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SDFPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSDFExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SDFTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SpecialNavigationStationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SpecialNavigationStationTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SpecialNavigationStationType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SpecialNavigationStationTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SpecialNavigationStationTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SpecialNavigationStationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSpecialNavigationStationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SpecialNavigationStationTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:SpecialNavigationStationStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSpecialNavigationStationStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "SpecialNavigationStationStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:SpecialNavigationStationStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SpecialNavigationStationStatusPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SpecialNavigationSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SpecialNavigationSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SpecialNavigationSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SpecialNavigationSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SpecialNavigationSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SpecialNavigationSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSpecialNavigationSystemExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SpecialNavigationSystemTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TACANPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TACANTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "TACANType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TACANTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TACANTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TACANPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractTACANExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TACANTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "VORPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:VORTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractNavaidEquipmentType"
          }
        },
        "_name": "VORType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:VORTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "VORTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:VORPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractVORExtension"
                      },
                      {
                        "_ref": "aixm:AbstractNavaidEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "VORTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AngleIndicationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AngleIndicationTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AngleIndicationType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AngleIndicationTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AngleIndicationTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AngleIndicationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAngleIndicationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AngleIndicationTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AngleUsePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAngleUseExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AngleUseType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AngleUse"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AngleUsePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DistanceIndicationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DistanceIndicationTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "DistanceIndicationType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DistanceIndicationTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DistanceIndicationTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DistanceIndicationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractDistanceIndicationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DistanceIndicationTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SegmentPointPropertyGroup"
                },
                {
                  "_ref": "aixm:EnRouteSegmentPointPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSegmentPointExtension"
                      },
                      {
                        "_ref": "aixm:AbstractEnRouteSegmentPointExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSegmentPointType"
          }
        },
        "_name": "EnRouteSegmentPointType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:EnRouteSegmentPoint"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "EnRouteSegmentPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PointReferencePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractPointReferenceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "PointReferenceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:PointReference"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "PointReferencePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": "",
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AbstractSegmentPointType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AbstractSegmentPoint"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SegmentPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:SegmentPointPropertyGroup"
                },
                {
                  "_ref": "aixm:TerminalSegmentPointPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSegmentPointExtension"
                      },
                      {
                        "_ref": "aixm:AbstractTerminalSegmentPointExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSegmentPointType"
          }
        },
        "_name": "TerminalSegmentPointType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:TerminalSegmentPoint"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "TerminalSegmentPointPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DesignatedPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DesignatedPointTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "DesignatedPointType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DesignatedPointTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DesignatedPointTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DesignatedPointPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractDesignatedPointExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DesignatedPointTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SignificantPointInAirspacePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SignificantPointInAirspaceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SignificantPointInAirspaceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SignificantPointInAirspaceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SignificantPointInAirspaceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SignificantPointInAirspacePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSignificantPointInAirspaceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SignificantPointInAirspaceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AeronauticalGroundLightPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AeronauticalGroundLightTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AeronauticalGroundLightType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AeronauticalGroundLightTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AeronauticalGroundLightTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AeronauticalGroundLightPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAeronauticalGroundLightExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AeronauticalGroundLightTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:LinguisticNotePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractLinguisticNoteExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "LinguisticNoteType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:LinguisticNote"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "LinguisticNotePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NotePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractNoteExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "NoteType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Note"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NotePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ObstacleAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ObstacleAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "ObstacleAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ObstacleAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ObstacleAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ObstacleAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractObstacleAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ObstacleAreaTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "VerticalStructurePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:VerticalStructureTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "VerticalStructureType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:VerticalStructureTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "VerticalStructureTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:VerticalStructurePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractVerticalStructureExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "VerticalStructureTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:VerticalStructureLightingStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractVerticalStructureLightingStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "VerticalStructureLightingStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:VerticalStructureLightingStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "VerticalStructureLightingStatusPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:VerticalStructurePartPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractVerticalStructurePartExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "VerticalStructurePartType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:VerticalStructurePart"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "VerticalStructurePartPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "OrganisationAuthorityPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:OrganisationAuthorityTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "OrganisationAuthorityType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:OrganisationAuthorityTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "OrganisationAuthorityTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:OrganisationAuthorityPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractOrganisationAuthorityExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "OrganisationAuthorityTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:OrganisationAuthorityAssociationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractOrganisationAuthorityAssociationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "OrganisationAuthorityAssociationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:OrganisationAuthorityAssociation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "OrganisationAuthorityAssociationPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "UnitPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:UnitTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "UnitType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:UnitTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "UnitTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:UnitPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractUnitExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "UnitTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:UnitAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractUnitAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "UnitAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:UnitAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "UnitAvailabilityPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:UnitDependencyPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractUnitDependencyExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "UnitDependencyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:UnitDependency"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "UnitDependencyPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApproachAltitudeTablePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractApproachAltitudeTableExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ApproachAltitudeTableType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApproachAltitudeTable"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApproachAltitudeTablePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApproachConditionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractApproachConditionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ApproachConditionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApproachCondition"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApproachConditionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApproachDistanceTablePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractApproachDistanceTableExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ApproachDistanceTableType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApproachDistanceTable"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApproachDistanceTablePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ApproachTimingTablePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractApproachTimingTableExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ApproachTimingTableType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ApproachTimingTable"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ApproachTimingTablePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FinalProfilePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFinalProfileExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FinalProfileType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FinalProfile"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FinalProfilePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "InstrumentApproachProcedurePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:InstrumentApproachProcedureTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractProcedureType"
          }
        },
        "_name": "InstrumentApproachProcedureType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:InstrumentApproachProcedureTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "InstrumentApproachProcedureTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:InstrumentApproachProcedurePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractInstrumentApproachProcedureExtension"
                      },
                      {
                        "_ref": "aixm:AbstractProcedureExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "InstrumentApproachProcedureTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MissedApproachGroupPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractMissedApproachGroupExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "MissedApproachGroupType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:MissedApproachGroup"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "MissedApproachGroupPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TerminalArrivalAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:TerminalArrivalAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "TerminalArrivalAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:TerminalArrivalAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "TerminalArrivalAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TerminalArrivalAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractTerminalArrivalAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "TerminalArrivalAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TerminalArrivalAreaSectorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractTerminalArrivalAreaSectorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "TerminalArrivalAreaSectorType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:TerminalArrivalAreaSector"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "TerminalArrivalAreaSectorPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FASDataBlockPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFASDataBlockExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FASDataBlockType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FASDataBlock"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FASDataBlockPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "CirclingAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:CirclingAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "CirclingAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:CirclingAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "CirclingAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CirclingAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractCirclingAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "CirclingAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:CirclingRestrictionPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractCirclingRestrictionExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "CirclingRestrictionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:CirclingRestriction"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "CirclingRestrictionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:EquipmentUnavailableAdjustmentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractEquipmentUnavailableAdjustmentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "EquipmentUnavailableAdjustmentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:EquipmentUnavailableAdjustment"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "EquipmentUnavailableAdjustmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:EquipmentUnavailableAdjustmentColumnPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractEquipmentUnavailableAdjustmentColumnExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "EquipmentUnavailableAdjustmentColumnType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:EquipmentUnavailableAdjustmentColumn"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "EquipmentUnavailableAdjustmentColumnPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MinimaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractMinimaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "MinimaType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Minima"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "MinimaPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "StandardInstrumentArrivalPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:StandardInstrumentArrivalTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractProcedureType"
          }
        },
        "_name": "StandardInstrumentArrivalType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:StandardInstrumentArrivalTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "StandardInstrumentArrivalTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandardInstrumentArrivalPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractStandardInstrumentArrivalExtension"
                      },
                      {
                        "_ref": "aixm:AbstractProcedureExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "StandardInstrumentArrivalTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DepartureArrivalConditionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractDepartureArrivalConditionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "DepartureArrivalConditionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:DepartureArrivalCondition"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "DepartureArrivalConditionPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NavigationAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:NavigationAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "NavigationAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:NavigationAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "NavigationAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NavigationAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractNavigationAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "NavigationAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NavigationAreaSectorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractNavigationAreaSectorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "NavigationAreaSectorType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:NavigationAreaSector"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NavigationAreaSectorPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SectorDesignPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractSectorDesignExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "SectorDesignType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:SectorDesign"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SectorDesignPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "StandardInstrumentDeparturePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:StandardInstrumentDepartureTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractProcedureType"
          }
        },
        "_name": "StandardInstrumentDepartureType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:StandardInstrumentDepartureTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "StandardInstrumentDepartureTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandardInstrumentDeparturePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractStandardInstrumentDepartureExtension"
                      },
                      {
                        "_ref": "aixm:AbstractProcedureExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "StandardInstrumentDepartureTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SafeAltitudeAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SafeAltitudeAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SafeAltitudeAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SafeAltitudeAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SafeAltitudeAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SafeAltitudeAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSafeAltitudeAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SafeAltitudeAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SafeAltitudeAreaSectorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractSafeAltitudeAreaSectorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "SafeAltitudeAreaSectorType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:SafeAltitudeAreaSector"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SafeAltitudeAreaSectorPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ApproachLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractSegmentLegType"
          }
        },
        "_name": "AbstractApproachLegType",
        "_abstract": "true"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ArrivalFeederLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ArrivalFeederLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractApproachLegType"
          }
        },
        "_name": "ArrivalFeederLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ArrivalFeederLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ArrivalFeederLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ArrivalFeederLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractArrivalFeederLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApproachLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ArrivalFeederLegTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ArrivalLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ArrivalLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSegmentLegType"
          }
        },
        "_name": "ArrivalLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ArrivalLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ArrivalLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ArrivalLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractArrivalLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ArrivalLegTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "DepartureLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:DepartureLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSegmentLegType"
          }
        },
        "_name": "DepartureLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:DepartureLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "DepartureLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:DepartureLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractDepartureLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "DepartureLegTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "FinalLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:FinalLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractApproachLegType"
          }
        },
        "_name": "FinalLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:FinalLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "FinalLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FinalLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractFinalLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApproachLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "FinalLegTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:HoldingUsePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractHoldingUseExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "HoldingUseType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:HoldingUse"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "HoldingUsePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "InitialLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:InitialLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractApproachLegType"
          }
        },
        "_name": "InitialLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:InitialLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "InitialLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:InitialLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractInitialLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApproachLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "InitialLegTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "IntermediateLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:IntermediateLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractApproachLegType"
          }
        },
        "_name": "IntermediateLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:IntermediateLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "IntermediateLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:IntermediateLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractIntermediateLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApproachLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "IntermediateLegTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:LandingTakeoffAreaCollectionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractLandingTakeoffAreaCollectionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "LandingTakeoffAreaCollectionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:LandingTakeoffAreaCollection"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "LandingTakeoffAreaCollectionPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "MissedApproachLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:MissedApproachLegTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractApproachLegType"
          }
        },
        "_name": "MissedApproachLegType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:MissedApproachLegTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "MissedApproachLegTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MissedApproachLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractMissedApproachLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractApproachLegExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSegmentLegExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "MissedApproachLegTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "NavigationAreaRestrictionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:NavigationAreaRestrictionTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "NavigationAreaRestrictionType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:NavigationAreaRestrictionTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "NavigationAreaRestrictionTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NavigationAreaRestrictionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractNavigationAreaRestrictionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "NavigationAreaRestrictionTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ProcedurePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractProcedureType",
        "_abstract": "true"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ProcedureDMEPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ProcedureDMETimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "ProcedureDMEType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ProcedureDMETimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ProcedureDMETimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ProcedureDMEPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractProcedureDMEExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ProcedureDMETimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ProcedureTransitionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractProcedureTransitionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ProcedureTransitionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ProcedureTransition"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ProcedureTransitionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ProcedureTransitionLegPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractProcedureTransitionLegExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ProcedureTransitionLegType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ProcedureTransitionLeg"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ProcedureTransitionLegPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SegmentLegPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractSegmentLegType",
        "_abstract": "true"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:ProcedureAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractProcedureAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "ProcedureAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ProcedureAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ProcedureAvailabilityPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ChangeOverPointPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:ChangeOverPointTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "ChangeOverPointType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:ChangeOverPointTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "ChangeOverPointTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ChangeOverPointPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractChangeOverPointExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "ChangeOverPointTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RoutePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RouteTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RouteType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RouteTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RouteTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RoutePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRouteExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RouteTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:RouteAvailabilityPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRouteAvailabilityExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "RouteAvailabilityType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RouteAvailability"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RouteAvailabilityPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RouteDMEPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RouteDMETimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RouteDMEType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RouteDMETimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RouteDMETimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RouteDMEPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRouteDMEExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RouteDMETimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RoutePortionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractRoutePortionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "RoutePortionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RoutePortion"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RoutePortionPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RouteSegmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RouteSegmentTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RouteSegmentType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RouteSegmentTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RouteSegmentTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RouteSegmentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRouteSegmentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RouteSegmentTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirspaceBorderCrossingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirspaceBorderCrossingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AirspaceBorderCrossingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirspaceBorderCrossingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirspaceBorderCrossingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirspaceBorderCrossingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractAirspaceBorderCrossingExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirspaceBorderCrossingTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": "",
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AbstractDirectFlightType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AbstractDirectFlight"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "DirectFlightPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:DirectFlightPropertyGroup"
                },
                {
                  "_ref": "aixm:DirectFlightClassPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractDirectFlightExtension"
                      },
                      {
                        "_ref": "aixm:AbstractDirectFlightClassExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractDirectFlightType"
          }
        },
        "_name": "DirectFlightClassType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:DirectFlightClass"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "DirectFlightClassPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:DirectFlightPropertyGroup"
                },
                {
                  "_ref": "aixm:DirectFlightSegmentPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractDirectFlightExtension"
                      },
                      {
                        "_ref": "aixm:AbstractDirectFlightSegmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractDirectFlightType"
          }
        },
        "_name": "DirectFlightSegmentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:DirectFlightSegment"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "DirectFlightSegmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightConditionCircumstancePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFlightConditionCircumstanceExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FlightConditionCircumstanceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightConditionCircumstance"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightConditionCircumstancePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:FlightConditionCombinationPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractFlightConditionCombinationExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "FlightConditionCombinationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightConditionCombination"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightConditionCombinationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightConditionElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFlightConditionElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FlightConditionElementType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightConditionElement"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightConditionElementPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "FlightRestrictionPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:FlightRestrictionTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "FlightRestrictionType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:FlightRestrictionTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "FlightRestrictionTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightRestrictionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractFlightRestrictionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "FlightRestrictionTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightRestrictionLevelPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFlightRestrictionLevelExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FlightRestrictionLevelType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightRestrictionLevel"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightRestrictionLevelPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightRestrictionRoutePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFlightRestrictionRouteExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FlightRestrictionRouteType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightRestrictionRoute"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightRestrictionRoutePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightRoutingElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFlightRoutingElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FlightRoutingElementType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightRoutingElement"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightRoutingElementPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RulesProceduresPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RulesProceduresTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RulesProceduresType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RulesProceduresTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RulesProceduresTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RulesProceduresPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRulesProceduresExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RulesProceduresTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AircraftGroundServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AircraftGroundServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportGroundServiceType"
          }
        },
        "_name": "AircraftGroundServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AircraftGroundServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AircraftGroundServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AircraftGroundServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAircraftGroundServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportGroundServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AircraftGroundServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportClearanceServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirportClearanceServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportGroundServiceType"
          }
        },
        "_name": "AirportClearanceServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirportClearanceServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirportClearanceServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirportClearanceServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAirportClearanceServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportGroundServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirportClearanceServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportGroundServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractServiceType"
          }
        },
        "_name": "AbstractAirportGroundServiceType",
        "_abstract": "true"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirportSuppliesServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirportSuppliesServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportGroundServiceType"
          }
        },
        "_name": "AirportSuppliesServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirportSuppliesServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirportSuppliesServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirportSuppliesServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAirportSuppliesServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportGroundServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirportSuppliesServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirTrafficControlServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirTrafficControlServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractTrafficSeparationServiceType"
          }
        },
        "_name": "AirTrafficControlServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirTrafficControlServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirTrafficControlServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirTrafficControlServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAirTrafficControlServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractTrafficSeparationServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirTrafficControlServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "AirTrafficManagementServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:AirTrafficManagementServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractServiceType"
          }
        },
        "_name": "AirTrafficManagementServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:AirTrafficManagementServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "AirTrafficManagementServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirTrafficManagementServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractAirTrafficManagementServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "AirTrafficManagementServiceTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CallsignDetailPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractCallsignDetailExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "CallsignDetailType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:CallsignDetail"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "CallsignDetailPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "FireFightingServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:FireFightingServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportGroundServiceType"
          }
        },
        "_name": "FireFightingServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:FireFightingServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "FireFightingServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FireFightingServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractFireFightingServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportGroundServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "FireFightingServiceTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FuelPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFuelExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FuelType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Fuel"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FuelPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "GroundTrafficControlServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:GroundTrafficControlServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractTrafficSeparationServiceType"
          }
        },
        "_name": "GroundTrafficControlServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:GroundTrafficControlServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "GroundTrafficControlServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:GroundTrafficControlServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractGroundTrafficControlServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractTrafficSeparationServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "GroundTrafficControlServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "InformationServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:InformationServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractServiceType"
          }
        },
        "_name": "InformationServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:InformationServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "InformationServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:InformationServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractInformationServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "InformationServiceTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:NitrogenPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractNitrogenExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "NitrogenType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Nitrogen"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "NitrogenPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:OilPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractOilExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "OilType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Oil"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "OilPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:OxygenPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractOxygenExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "OxygenType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Oxygen"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "OxygenPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "PassengerServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:PassengerServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAirportGroundServiceType"
          }
        },
        "_name": "PassengerServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:PassengerServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "PassengerServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PassengerServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPassengerServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractAirportGroundServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "PassengerServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "PilotControlledLightingPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:PilotControlledLightingTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "PilotControlledLightingType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:PilotControlledLightingTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "PilotControlledLightingTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PilotControlledLightingPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractPilotControlledLightingExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "PilotControlledLightingTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RadioCommunicationChannelPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RadioCommunicationChannelTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RadioCommunicationChannelType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RadioCommunicationChannelTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RadioCommunicationChannelTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RadioCommunicationChannelPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRadioCommunicationChannelExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RadioCommunicationChannelTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:RadioCommunicationOperationalStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRadioCommunicationOperationalStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "RadioCommunicationOperationalStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RadioCommunicationOperationalStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RadioCommunicationOperationalStatusPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SearchRescueServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SearchRescueServiceTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractServiceType"
          }
        },
        "_name": "SearchRescueServiceType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SearchRescueServiceTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SearchRescueServiceTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SearchRescueServicePropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSearchRescueServiceExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SearchRescueServiceTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "ServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractServiceType",
        "_abstract": "true"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:ServiceOperationalStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractServiceOperationalStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "ServiceOperationalStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ServiceOperationalStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ServiceOperationalStatusPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "TrafficSeparationServicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractServiceType"
          }
        },
        "_name": "AbstractTrafficSeparationServiceType",
        "_abstract": "true"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ContactInformationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractContactInformationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ContactInformationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ContactInformation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ContactInformationPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:OnlineContactPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractOnlineContactExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "OnlineContactType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:OnlineContact"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "OnlineContactPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:PostalAddressPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractPostalAddressExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "PostalAddressType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:PostalAddress"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "PostalAddressPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:TelephoneContactPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractTelephoneContactExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "TelephoneContactType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:TelephoneContact"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "TelephoneContactPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AircraftCharacteristicPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAircraftCharacteristicExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AircraftCharacteristicType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AircraftCharacteristic"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AircraftCharacteristicPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:FlightCharacteristicPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractFlightCharacteristicExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "FlightCharacteristicType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:FlightCharacteristic"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "FlightCharacteristicPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AirspaceLayerPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAirspaceLayerExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AirspaceLayerType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AirspaceLayer"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AirspaceLayerPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:CircleSectorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractCircleSectorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "CircleSectorType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:CircleSector"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "CircleSectorPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:LightElementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractLightElementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "LightElementType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:LightElement"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "LightElementPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": [
                {
                  "_ref": "aixm:PropertiesWithSchedulePropertyGroup"
                },
                {
                  "_ref": "aixm:LightElementStatusPropertyGroup"
                }
              ],
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPropertiesWithScheduleExtension"
                      },
                      {
                        "_ref": "aixm:AbstractLightElementStatusExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractPropertiesWithScheduleType"
          }
        },
        "_name": "LightElementStatusType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:LightElementStatus"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "LightElementStatusPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:MeteorologyPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractMeteorologyExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "MeteorologyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Meteorology"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "MeteorologyPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RadioFrequencyAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RadioFrequencyAreaTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RadioFrequencyAreaType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RadioFrequencyAreaTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RadioFrequencyAreaTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RadioFrequencyAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRadioFrequencyAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RadioFrequencyAreaTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": "",
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AbstractPropertiesWithScheduleType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AbstractPropertiesWithSchedule"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "PropertiesWithSchedulePropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SpecialDatePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SpecialDateTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "SpecialDateType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SpecialDateTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SpecialDateTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SpecialDatePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractSpecialDateExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SpecialDateTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:TimesheetPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractTimesheetExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "TimesheetType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Timesheet"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "TimesheetPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandardLevelPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractStandardLevelExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "StandardLevelType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:StandardLevel"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "StandardLevelPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "StandardLevelColumnPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:StandardLevelColumnTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "StandardLevelColumnType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:StandardLevelColumnTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "StandardLevelColumnTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandardLevelColumnPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractStandardLevelColumnExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "StandardLevelColumnTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "StandardLevelSectorPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:StandardLevelSectorTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "StandardLevelSectorType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:StandardLevelSectorTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "StandardLevelSectorTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandardLevelSectorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractStandardLevelSectorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "StandardLevelSectorTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "StandardLevelTablePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:StandardLevelTableTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "StandardLevelTableType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:StandardLevelTableTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "StandardLevelTableTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:StandardLevelTablePropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractStandardLevelTableExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "StandardLevelTableTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:AltitudeAdjustmentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractAltitudeAdjustmentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "AltitudeAdjustmentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:AltitudeAdjustment"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "AltitudeAdjustmentPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "HoldingAssessmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:HoldingAssessmentTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "HoldingAssessmentType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:HoldingAssessmentTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "HoldingAssessmentTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:HoldingAssessmentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractHoldingAssessmentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "HoldingAssessmentTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ObstacleAssessmentAreaPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractObstacleAssessmentAreaExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ObstacleAssessmentAreaType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ObstacleAssessmentArea"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ObstacleAssessmentAreaPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ObstaclePlacementPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractObstaclePlacementExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ObstaclePlacementType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:ObstaclePlacement"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ObstaclePlacementPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ObstructionPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractObstructionExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ObstructionType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Obstruction"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ObstructionPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "PrecisionApproachRadarPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:PrecisionApproachRadarTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractRadarEquipmentType"
          }
        },
        "_name": "PrecisionApproachRadarType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:PrecisionApproachRadarTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "PrecisionApproachRadarTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PrecisionApproachRadarPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPrecisionApproachRadarExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRadarEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "PrecisionApproachRadarTimeSliceType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "PrimarySurveillanceRadarPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:PrimarySurveillanceRadarTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurveillanceRadarType"
          }
        },
        "_name": "PrimarySurveillanceRadarType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:PrimarySurveillanceRadarTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "PrimarySurveillanceRadarTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:PrimarySurveillanceRadarPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractPrimarySurveillanceRadarExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSurveillanceRadarExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRadarEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "PrimarySurveillanceRadarTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RadarComponentPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractRadarComponentExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "RadarComponentType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:RadarComponent"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "RadarComponentPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RadarEquipmentPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "AbstractRadarEquipmentType",
        "_abstract": "true"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "RadarSystemPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:RadarSystemTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMFeatureType"
          }
        },
        "_name": "RadarSystemType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:RadarSystemTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "RadarSystemTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:RadarSystemPropertyGroup"
              },
              "element": {
                "complexType": {
                  "sequence": {
                    "element": {
                      "_ref": "aixm:AbstractRadarSystemExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "RadarSystemTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:ReflectorPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractReflectorExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "ReflectorType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:Reflector"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "ReflectorPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SecondarySurveillanceRadarPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_name": "timeSlice",
                "_type": "aixm:SecondarySurveillanceRadarTimeSlicePropertyType",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractSurveillanceRadarType"
          }
        },
        "_name": "SecondarySurveillanceRadarType"
      },
      {
        "sequence": {
          "element": {
            "_ref": "aixm:SecondarySurveillanceRadarTimeSlice"
          }
        },
        "attributeGroup": {
          "_ref": "gml:OwnershipAttributeGroup"
        },
        "_name": "SecondarySurveillanceRadarTimeSlicePropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SecondarySurveillanceRadarPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": [
                      {
                        "_ref": "aixm:AbstractSecondarySurveillanceRadarExtension"
                      },
                      {
                        "_ref": "aixm:AbstractSurveillanceRadarExtension"
                      },
                      {
                        "_ref": "aixm:AbstractRadarEquipmentExtension"
                      }
                    ]
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMTimeSliceType"
          }
        },
        "_name": "SecondarySurveillanceRadarTimeSliceType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "group": {
                "_ref": "aixm:SurveillanceGroundStationPropertyGroup"
              },
              "element": {
                "complexType": {
                  "choice": {
                    "element": {
                      "_ref": "aixm:AbstractSurveillanceGroundStationExtension"
                    }
                  },
                  "attributeGroup": {
                    "_ref": "gml:OwnershipAttributeGroup"
                  }
                },
                "_name": "extension",
                "_minOccurs": "0",
                "_maxOccurs": "unbounded"
              }
            },
            "_base": "aixm:AbstractAIXMObjectType"
          }
        },
        "_name": "SurveillanceGroundStationType"
      },
      {
        "complexContent": {
          "extension": {
            "sequence": {
              "element": {
                "_ref": "aixm:SurveillanceGroundStation"
              }
            },
            "_base": "aixm:AbstractAIXMPropertyType"
          }
        },
        "_name": "SurveillanceGroundStationPropertyType"
      },
      {
        "attributeGroup": [
          {
            "_ref": "gml:OwnershipAttributeGroup"
          },
          {
            "_ref": "gml:AssociationAttributeGroup"
          }
        ],
        "_name": "SurveillanceRadarPropertyType"
      },
      {
        "complexContent": {
          "extension": {
            "_base": "aixm:AbstractRadarEquipmentType"
          }
        },
        "_name": "AbstractSurveillanceRadarType",
        "_abstract": "true"
      }
    ],
    "element": [
      {
        "_name": "AerialRefuelling",
        "_type": "aixm:AerialRefuellingType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AerialRefuellingTimeSlice",
        "_type": "aixm:AerialRefuellingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAerialRefuellingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AerialRefuellingAnchor",
        "_type": "aixm:AerialRefuellingAnchorType"
      },
      {
        "_name": "AbstractAerialRefuellingAnchorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AerialRefuellingPoint",
        "_type": "aixm:AerialRefuellingPointType",
        "_substitutionGroup": "aixm:AbstractSegmentPoint"
      },
      {
        "_name": "AbstractAerialRefuellingPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AerialRefuellingTrack",
        "_type": "aixm:AerialRefuellingTrackType"
      },
      {
        "_name": "AbstractAerialRefuellingTrackExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AuthorityForAerialRefuelling",
        "_type": "aixm:AuthorityForAerialRefuellingType"
      },
      {
        "_name": "AbstractAuthorityForAerialRefuellingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHeliport",
        "_type": "aixm:AirportHeliportType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AirportHeliportTimeSlice",
        "_type": "aixm:AirportHeliportTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirportHeliportExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHeliportAvailability",
        "_type": "aixm:AirportHeliportAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractAirportHeliportAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHeliportCollocation",
        "_type": "aixm:AirportHeliportCollocationType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AirportHeliportCollocationTimeSlice",
        "_type": "aixm:AirportHeliportCollocationTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirportHeliportCollocationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractAirportHeliportProtectionArea",
        "_type": "aixm:AbstractAirportHeliportProtectionAreaType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractAirportHeliportProtectionAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHeliportResponsibilityOrganisation",
        "_type": "aixm:AirportHeliportResponsibilityOrganisationType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractAirportHeliportResponsibilityOrganisationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHeliportUsage",
        "_type": "aixm:AirportHeliportUsageType",
        "_substitutionGroup": "aixm:AbstractUsageCondition"
      },
      {
        "_name": "AbstractAirportHeliportUsageExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHotSpot",
        "_type": "aixm:AirportHotSpotType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AirportHotSpotTimeSlice",
        "_type": "aixm:AirportHotSpotTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirportHotSpotExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AltimeterSource",
        "_type": "aixm:AltimeterSourceType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AltimeterSourceTimeSlice",
        "_type": "aixm:AltimeterSourceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAltimeterSourceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AltimeterSourceStatus",
        "_type": "aixm:AltimeterSourceStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractAltimeterSourceStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "City",
        "_type": "aixm:CityType"
      },
      {
        "_name": "AbstractCityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ConditionCombination",
        "_type": "aixm:ConditionCombinationType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractConditionCombinationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NonMovementArea",
        "_type": "aixm:NonMovementAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "NonMovementAreaTimeSlice",
        "_type": "aixm:NonMovementAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractNonMovementAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SurfaceCharacteristics",
        "_type": "aixm:SurfaceCharacteristicsType"
      },
      {
        "_name": "AbstractSurfaceCharacteristicsExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SurveyControlPoint",
        "_type": "aixm:SurveyControlPointType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SurveyControlPointTimeSlice",
        "_type": "aixm:SurveyControlPointTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSurveyControlPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractUsageCondition",
        "_type": "aixm:AbstractUsageConditionType",
        "_abstract": "true"
      },
      {
        "_name": "AbstractUsageConditionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "WorkArea",
        "_type": "aixm:WorkAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "WorkAreaTimeSlice",
        "_type": "aixm:WorkAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractWorkAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "WorkareaActivity",
        "_type": "aixm:WorkareaActivityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractWorkareaActivityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AircraftStand",
        "_type": "aixm:AircraftStandType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AircraftStandTimeSlice",
        "_type": "aixm:AircraftStandTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAircraftStandExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Apron",
        "_type": "aixm:ApronType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "ApronTimeSlice",
        "_type": "aixm:ApronTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractApronExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApronAreaAvailability",
        "_type": "aixm:ApronAreaAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractApronAreaAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApronAreaUsage",
        "_type": "aixm:ApronAreaUsageType",
        "_substitutionGroup": "aixm:AbstractUsageCondition"
      },
      {
        "_name": "AbstractApronAreaUsageExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApronElement",
        "_type": "aixm:ApronElementType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "ApronElementTimeSlice",
        "_type": "aixm:ApronElementTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractApronElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DeicingArea",
        "_type": "aixm:DeicingAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "DeicingAreaTimeSlice",
        "_type": "aixm:DeicingAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDeicingAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PassengerLoadingBridge",
        "_type": "aixm:PassengerLoadingBridgeType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "PassengerLoadingBridgeTimeSlice",
        "_type": "aixm:PassengerLoadingBridgeTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractPassengerLoadingBridgeExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Road",
        "_type": "aixm:RoadType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RoadTimeSlice",
        "_type": "aixm:RoadTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRoadExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TouchDownLiftOff",
        "_type": "aixm:TouchDownLiftOffType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "TouchDownLiftOffTimeSlice",
        "_type": "aixm:TouchDownLiftOffTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTouchDownLiftOffExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TouchDownLiftOffSafeArea",
        "_type": "aixm:TouchDownLiftOffSafeAreaType",
        "_substitutionGroup": "aixm:AbstractAirportHeliportProtectionArea"
      },
      {
        "_name": "TouchDownLiftOffSafeAreaTimeSlice",
        "_type": "aixm:TouchDownLiftOffSafeAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTouchDownLiftOffSafeAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApproachLightingSystem",
        "_type": "aixm:ApproachLightingSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "ApproachLightingSystemTimeSlice",
        "_type": "aixm:ApproachLightingSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractApproachLightingSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApronLightSystem",
        "_type": "aixm:ApronLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "ApronLightSystemTimeSlice",
        "_type": "aixm:ApronLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractApronLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "GroundLightingAvailability",
        "_type": "aixm:GroundLightingAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractGroundLightingAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractGroundLightSystem",
        "_type": "aixm:AbstractGroundLightSystemType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractGroundLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "GuidanceLineLightSystem",
        "_type": "aixm:GuidanceLineLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "GuidanceLineLightSystemTimeSlice",
        "_type": "aixm:GuidanceLineLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractGuidanceLineLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "LightActivation",
        "_type": "aixm:LightActivationType"
      },
      {
        "_name": "AbstractLightActivationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayDirectionLightSystem",
        "_type": "aixm:RunwayDirectionLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "RunwayDirectionLightSystemTimeSlice",
        "_type": "aixm:RunwayDirectionLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayDirectionLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayProtectAreaLightSystem",
        "_type": "aixm:RunwayProtectAreaLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "RunwayProtectAreaLightSystemTimeSlice",
        "_type": "aixm:RunwayProtectAreaLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayProtectAreaLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiHoldingPositionLightSystem",
        "_type": "aixm:TaxiHoldingPositionLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "TaxiHoldingPositionLightSystemTimeSlice",
        "_type": "aixm:TaxiHoldingPositionLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiHoldingPositionLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiwayLightSystem",
        "_type": "aixm:TaxiwayLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "TaxiwayLightSystemTimeSlice",
        "_type": "aixm:TaxiwayLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiwayLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TouchDownLiftOffLightSystem",
        "_type": "aixm:TouchDownLiftOffLightSystemType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "TouchDownLiftOffLightSystemTimeSlice",
        "_type": "aixm:TouchDownLiftOffLightSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTouchDownLiftOffLightSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportProtectionAreaMarking",
        "_type": "aixm:AirportProtectionAreaMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "AirportProtectionAreaMarkingTimeSlice",
        "_type": "aixm:AirportProtectionAreaMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirportProtectionAreaMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApronMarking",
        "_type": "aixm:ApronMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "ApronMarkingTimeSlice",
        "_type": "aixm:ApronMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractApronMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DeicingAreaMarking",
        "_type": "aixm:DeicingAreaMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "DeicingAreaMarkingTimeSlice",
        "_type": "aixm:DeicingAreaMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDeicingAreaMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "GuidanceLineMarking",
        "_type": "aixm:GuidanceLineMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "GuidanceLineMarkingTimeSlice",
        "_type": "aixm:GuidanceLineMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractGuidanceLineMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractMarking",
        "_type": "aixm:AbstractMarkingType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "MarkingElement",
        "_type": "aixm:MarkingElementType"
      },
      {
        "_name": "AbstractMarkingElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayMarking",
        "_type": "aixm:RunwayMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "RunwayMarkingTimeSlice",
        "_type": "aixm:RunwayMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandMarking",
        "_type": "aixm:StandMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "StandMarkingTimeSlice",
        "_type": "aixm:StandMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractStandMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiHoldingPositionMarking",
        "_type": "aixm:TaxiHoldingPositionMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "TaxiHoldingPositionMarkingTimeSlice",
        "_type": "aixm:TaxiHoldingPositionMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiHoldingPositionMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiwayMarking",
        "_type": "aixm:TaxiwayMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "TaxiwayMarkingTimeSlice",
        "_type": "aixm:TaxiwayMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiwayMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TouchDownLiftOffMarking",
        "_type": "aixm:TouchDownLiftOffMarkingType",
        "_substitutionGroup": "aixm:AbstractMarking"
      },
      {
        "_name": "TouchDownLiftOffMarkingTimeSlice",
        "_type": "aixm:TouchDownLiftOffMarkingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTouchDownLiftOffMarkingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ArrestingGear",
        "_type": "aixm:ArrestingGearType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "ArrestingGearTimeSlice",
        "_type": "aixm:ArrestingGearTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractArrestingGearExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ManoeuvringAreaAvailability",
        "_type": "aixm:ManoeuvringAreaAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractManoeuvringAreaAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ManoeuvringAreaUsage",
        "_type": "aixm:ManoeuvringAreaUsageType",
        "_substitutionGroup": "aixm:AbstractUsageCondition"
      },
      {
        "_name": "AbstractManoeuvringAreaUsageExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavaidEquipmentDistance",
        "_type": "aixm:NavaidEquipmentDistanceType"
      },
      {
        "_name": "AbstractNavaidEquipmentDistanceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Runway",
        "_type": "aixm:RunwayType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RunwayTimeSlice",
        "_type": "aixm:RunwayTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayBlastPad",
        "_type": "aixm:RunwayBlastPadType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RunwayBlastPadTimeSlice",
        "_type": "aixm:RunwayBlastPadTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayBlastPadExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayCentrelinePoint",
        "_type": "aixm:RunwayCentrelinePointType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RunwayCentrelinePointTimeSlice",
        "_type": "aixm:RunwayCentrelinePointTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayCentrelinePointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayDeclaredDistance",
        "_type": "aixm:RunwayDeclaredDistanceType"
      },
      {
        "_name": "AbstractRunwayDeclaredDistanceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayDeclaredDistanceValue",
        "_type": "aixm:RunwayDeclaredDistanceValueType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractRunwayDeclaredDistanceValueExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayDirection",
        "_type": "aixm:RunwayDirectionType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RunwayDirectionTimeSlice",
        "_type": "aixm:RunwayDirectionTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayDirectionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayElement",
        "_type": "aixm:RunwayElementType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RunwayElementTimeSlice",
        "_type": "aixm:RunwayElementTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayProtectArea",
        "_type": "aixm:RunwayProtectAreaType",
        "_substitutionGroup": "aixm:AbstractAirportHeliportProtectionArea"
      },
      {
        "_name": "RunwayProtectAreaTimeSlice",
        "_type": "aixm:RunwayProtectAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayProtectAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayVisualRange",
        "_type": "aixm:RunwayVisualRangeType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RunwayVisualRangeTimeSlice",
        "_type": "aixm:RunwayVisualRangeTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRunwayVisualRangeExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "VisualGlideSlopeIndicator",
        "_type": "aixm:VisualGlideSlopeIndicatorType",
        "_substitutionGroup": "aixm:AbstractGroundLightSystem"
      },
      {
        "_name": "VisualGlideSlopeIndicatorTimeSlice",
        "_type": "aixm:VisualGlideSlopeIndicatorTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractVisualGlideSlopeIndicatorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FloatingDockSite",
        "_type": "aixm:FloatingDockSiteType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "FloatingDockSiteTimeSlice",
        "_type": "aixm:FloatingDockSiteTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractFloatingDockSiteExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "MarkingBuoy",
        "_type": "aixm:MarkingBuoyType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "MarkingBuoyTimeSlice",
        "_type": "aixm:MarkingBuoyTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractMarkingBuoyExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SeaplaneLandingArea",
        "_type": "aixm:SeaplaneLandingAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SeaplaneLandingAreaTimeSlice",
        "_type": "aixm:SeaplaneLandingAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSeaplaneLandingAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SeaplaneRampSite",
        "_type": "aixm:SeaplaneRampSiteType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SeaplaneRampSiteTimeSlice",
        "_type": "aixm:SeaplaneRampSiteTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSeaplaneRampSiteExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AircraftStandContamination",
        "_type": "aixm:AircraftStandContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractAircraftStandContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportHeliportContamination",
        "_type": "aixm:AirportHeliportContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractAirportHeliportContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApronContamination",
        "_type": "aixm:ApronContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractApronContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Ridge",
        "_type": "aixm:RidgeType"
      },
      {
        "_name": "AbstractRidgeExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwayContamination",
        "_type": "aixm:RunwayContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractRunwayContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RunwaySectionContamination",
        "_type": "aixm:RunwaySectionContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractRunwaySectionContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractSurfaceContamination",
        "_type": "aixm:AbstractSurfaceContaminationType",
        "_abstract": "true"
      },
      {
        "_name": "AbstractSurfaceContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SurfaceContaminationLayer",
        "_type": "aixm:SurfaceContaminationLayerType"
      },
      {
        "_name": "AbstractSurfaceContaminationLayerExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiwayContamination",
        "_type": "aixm:TaxiwayContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractTaxiwayContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TouchDownLiftOffContamination",
        "_type": "aixm:TouchDownLiftOffContaminationType",
        "_substitutionGroup": "aixm:AbstractSurfaceContamination"
      },
      {
        "_name": "AbstractTouchDownLiftOffContaminationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "GuidanceLine",
        "_type": "aixm:GuidanceLineType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "GuidanceLineTimeSlice",
        "_type": "aixm:GuidanceLineTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractGuidanceLineExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiHoldingPosition",
        "_type": "aixm:TaxiHoldingPositionType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "TaxiHoldingPositionTimeSlice",
        "_type": "aixm:TaxiHoldingPositionTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiHoldingPositionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Taxiway",
        "_type": "aixm:TaxiwayType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "TaxiwayTimeSlice",
        "_type": "aixm:TaxiwayTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiwayExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TaxiwayElement",
        "_type": "aixm:TaxiwayElementType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "TaxiwayElementTimeSlice",
        "_type": "aixm:TaxiwayElementTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTaxiwayElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Airspace",
        "_type": "aixm:AirspaceType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AirspaceTimeSlice",
        "_type": "aixm:AirspaceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirspaceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceActivation",
        "_type": "aixm:AirspaceActivationType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractAirspaceActivationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceGeometryComponent",
        "_type": "aixm:AirspaceGeometryComponentType"
      },
      {
        "_name": "AbstractAirspaceGeometryComponentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceLayerClass",
        "_type": "aixm:AirspaceLayerClassType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractAirspaceLayerClassExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceVolume",
        "_type": "aixm:AirspaceVolumeType"
      },
      {
        "_name": "AbstractAirspaceVolumeExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceVolumeDependency",
        "_type": "aixm:AirspaceVolumeDependencyType"
      },
      {
        "_name": "AbstractAirspaceVolumeDependencyExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AuthorityForAirspace",
        "_type": "aixm:AuthorityForAirspaceType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AuthorityForAirspaceTimeSlice",
        "_type": "aixm:AuthorityForAirspaceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAuthorityForAirspaceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "GeoBorder",
        "_type": "aixm:GeoBorderType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "GeoBorderTimeSlice",
        "_type": "aixm:GeoBorderTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractGeoBorderExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Curve",
        "_type": "aixm:CurveType",
        "_substitutionGroup": "gml:Curve"
      },
      {
        "_name": "ElevatedCurve",
        "_type": "aixm:ElevatedCurveType",
        "_substitutionGroup": "aixm:Curve"
      },
      {
        "_name": "AbstractElevatedCurveExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ElevatedPoint",
        "_type": "aixm:ElevatedPointType",
        "_substitutionGroup": "aixm:Point"
      },
      {
        "_name": "AbstractElevatedPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ElevatedSurface",
        "_type": "aixm:ElevatedSurfaceType",
        "_substitutionGroup": "aixm:Surface"
      },
      {
        "_name": "AbstractElevatedSurfaceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Point",
        "_type": "aixm:PointType",
        "_substitutionGroup": "gml:Point"
      },
      {
        "_name": "Surface",
        "_type": "aixm:SurfaceType",
        "_substitutionGroup": "gml:Surface"
      },
      {
        "_name": "HoldingPattern",
        "_type": "aixm:HoldingPatternType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "HoldingPatternTimeSlice",
        "_type": "aixm:HoldingPatternTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractHoldingPatternExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "HoldingPatternDistance",
        "_type": "aixm:HoldingPatternDistanceType"
      },
      {
        "_name": "AbstractHoldingPatternDistanceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "HoldingPatternDuration",
        "_type": "aixm:HoldingPatternDurationType"
      },
      {
        "_name": "AbstractHoldingPatternDurationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "UnplannedHolding",
        "_type": "aixm:UnplannedHoldingType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "UnplannedHoldingTimeSlice",
        "_type": "aixm:UnplannedHoldingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractUnplannedHoldingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AuthorityForNavaidEquipment",
        "_type": "aixm:AuthorityForNavaidEquipmentType"
      },
      {
        "_name": "AbstractAuthorityForNavaidEquipmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AuthorityForSpecialNavigationStation",
        "_type": "aixm:AuthorityForSpecialNavigationStationType"
      },
      {
        "_name": "AbstractAuthorityForSpecialNavigationStationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AuthorityForSpecialNavigationSystem",
        "_type": "aixm:AuthorityForSpecialNavigationSystemType"
      },
      {
        "_name": "AbstractAuthorityForSpecialNavigationSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Azimuth",
        "_type": "aixm:AzimuthType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "AzimuthTimeSlice",
        "_type": "aixm:AzimuthTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAzimuthExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "CheckpointINS",
        "_type": "aixm:CheckpointINSType",
        "_substitutionGroup": "aixm:AbstractNavigationSystemCheckpoint"
      },
      {
        "_name": "CheckpointINSTimeSlice",
        "_type": "aixm:CheckpointINSTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractCheckpointINSExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "CheckpointVOR",
        "_type": "aixm:CheckpointVORType",
        "_substitutionGroup": "aixm:AbstractNavigationSystemCheckpoint"
      },
      {
        "_name": "CheckpointVORTimeSlice",
        "_type": "aixm:CheckpointVORTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractCheckpointVORExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DirectionFinder",
        "_type": "aixm:DirectionFinderType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "DirectionFinderTimeSlice",
        "_type": "aixm:DirectionFinderTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDirectionFinderExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DME",
        "_type": "aixm:DMEType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "DMETimeSlice",
        "_type": "aixm:DMETimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDMEExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Elevation",
        "_type": "aixm:ElevationType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "ElevationTimeSlice",
        "_type": "aixm:ElevationTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractElevationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Glidepath",
        "_type": "aixm:GlidepathType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "GlidepathTimeSlice",
        "_type": "aixm:GlidepathTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractGlidepathExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Localizer",
        "_type": "aixm:LocalizerType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "LocalizerTimeSlice",
        "_type": "aixm:LocalizerTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractLocalizerExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "MarkerBeacon",
        "_type": "aixm:MarkerBeaconType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "MarkerBeaconTimeSlice",
        "_type": "aixm:MarkerBeaconTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractMarkerBeaconExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Navaid",
        "_type": "aixm:NavaidType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "NavaidTimeSlice",
        "_type": "aixm:NavaidTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractNavaidExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavaidComponent",
        "_type": "aixm:NavaidComponentType"
      },
      {
        "_name": "AbstractNavaidComponentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractNavaidEquipment",
        "_type": "aixm:AbstractNavaidEquipmentType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractNavaidEquipmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavaidEquipmentMonitoring",
        "_type": "aixm:NavaidEquipmentMonitoringType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractNavaidEquipmentMonitoringExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavaidOperationalStatus",
        "_type": "aixm:NavaidOperationalStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractNavaidOperationalStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractNavigationSystemCheckpoint",
        "_type": "aixm:AbstractNavigationSystemCheckpointType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractNavigationSystemCheckpointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NDB",
        "_type": "aixm:NDBType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "NDBTimeSlice",
        "_type": "aixm:NDBTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractNDBExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SDF",
        "_type": "aixm:SDFType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "SDFTimeSlice",
        "_type": "aixm:SDFTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSDFExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SpecialNavigationStation",
        "_type": "aixm:SpecialNavigationStationType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SpecialNavigationStationTimeSlice",
        "_type": "aixm:SpecialNavigationStationTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSpecialNavigationStationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SpecialNavigationStationStatus",
        "_type": "aixm:SpecialNavigationStationStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractSpecialNavigationStationStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SpecialNavigationSystem",
        "_type": "aixm:SpecialNavigationSystemType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SpecialNavigationSystemTimeSlice",
        "_type": "aixm:SpecialNavigationSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSpecialNavigationSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TACAN",
        "_type": "aixm:TACANType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "TACANTimeSlice",
        "_type": "aixm:TACANTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTACANExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "VOR",
        "_type": "aixm:VORType",
        "_substitutionGroup": "aixm:AbstractNavaidEquipment"
      },
      {
        "_name": "VORTimeSlice",
        "_type": "aixm:VORTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractVORExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AngleIndication",
        "_type": "aixm:AngleIndicationType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AngleIndicationTimeSlice",
        "_type": "aixm:AngleIndicationTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAngleIndicationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AngleUse",
        "_type": "aixm:AngleUseType"
      },
      {
        "_name": "AbstractAngleUseExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DistanceIndication",
        "_type": "aixm:DistanceIndicationType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "DistanceIndicationTimeSlice",
        "_type": "aixm:DistanceIndicationTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDistanceIndicationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "EnRouteSegmentPoint",
        "_type": "aixm:EnRouteSegmentPointType",
        "_substitutionGroup": "aixm:AbstractSegmentPoint"
      },
      {
        "_name": "AbstractEnRouteSegmentPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PointReference",
        "_type": "aixm:PointReferenceType"
      },
      {
        "_name": "AbstractPointReferenceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractSegmentPoint",
        "_type": "aixm:AbstractSegmentPointType",
        "_abstract": "true"
      },
      {
        "_name": "AbstractSegmentPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TerminalSegmentPoint",
        "_type": "aixm:TerminalSegmentPointType",
        "_substitutionGroup": "aixm:AbstractSegmentPoint"
      },
      {
        "_name": "AbstractTerminalSegmentPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DesignatedPoint",
        "_type": "aixm:DesignatedPointType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "DesignatedPointTimeSlice",
        "_type": "aixm:DesignatedPointTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDesignatedPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SignificantPointInAirspace",
        "_type": "aixm:SignificantPointInAirspaceType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SignificantPointInAirspaceTimeSlice",
        "_type": "aixm:SignificantPointInAirspaceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSignificantPointInAirspaceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AeronauticalGroundLight",
        "_type": "aixm:AeronauticalGroundLightType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AeronauticalGroundLightTimeSlice",
        "_type": "aixm:AeronauticalGroundLightTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAeronauticalGroundLightExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "LinguisticNote",
        "_type": "aixm:LinguisticNoteType"
      },
      {
        "_name": "AbstractLinguisticNoteExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Note",
        "_type": "aixm:NoteType"
      },
      {
        "_name": "AbstractNoteExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ObstacleArea",
        "_type": "aixm:ObstacleAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "ObstacleAreaTimeSlice",
        "_type": "aixm:ObstacleAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractObstacleAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "VerticalStructure",
        "_type": "aixm:VerticalStructureType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "VerticalStructureTimeSlice",
        "_type": "aixm:VerticalStructureTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractVerticalStructureExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "VerticalStructureLightingStatus",
        "_type": "aixm:VerticalStructureLightingStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractVerticalStructureLightingStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "VerticalStructurePart",
        "_type": "aixm:VerticalStructurePartType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractVerticalStructurePartExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "OrganisationAuthority",
        "_type": "aixm:OrganisationAuthorityType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "OrganisationAuthorityTimeSlice",
        "_type": "aixm:OrganisationAuthorityTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractOrganisationAuthorityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "OrganisationAuthorityAssociation",
        "_type": "aixm:OrganisationAuthorityAssociationType"
      },
      {
        "_name": "AbstractOrganisationAuthorityAssociationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Unit",
        "_type": "aixm:UnitType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "UnitTimeSlice",
        "_type": "aixm:UnitTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractUnitExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "UnitAvailability",
        "_type": "aixm:UnitAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractUnitAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "UnitDependency",
        "_type": "aixm:UnitDependencyType"
      },
      {
        "_name": "AbstractUnitDependencyExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApproachAltitudeTable",
        "_type": "aixm:ApproachAltitudeTableType"
      },
      {
        "_name": "AbstractApproachAltitudeTableExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApproachCondition",
        "_type": "aixm:ApproachConditionType"
      },
      {
        "_name": "AbstractApproachConditionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApproachDistanceTable",
        "_type": "aixm:ApproachDistanceTableType"
      },
      {
        "_name": "AbstractApproachDistanceTableExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ApproachTimingTable",
        "_type": "aixm:ApproachTimingTableType"
      },
      {
        "_name": "AbstractApproachTimingTableExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FinalProfile",
        "_type": "aixm:FinalProfileType"
      },
      {
        "_name": "AbstractFinalProfileExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "InstrumentApproachProcedure",
        "_type": "aixm:InstrumentApproachProcedureType",
        "_substitutionGroup": "aixm:AbstractProcedure"
      },
      {
        "_name": "InstrumentApproachProcedureTimeSlice",
        "_type": "aixm:InstrumentApproachProcedureTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractInstrumentApproachProcedureExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "MissedApproachGroup",
        "_type": "aixm:MissedApproachGroupType"
      },
      {
        "_name": "AbstractMissedApproachGroupExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TerminalArrivalArea",
        "_type": "aixm:TerminalArrivalAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "TerminalArrivalAreaTimeSlice",
        "_type": "aixm:TerminalArrivalAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractTerminalArrivalAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TerminalArrivalAreaSector",
        "_type": "aixm:TerminalArrivalAreaSectorType"
      },
      {
        "_name": "AbstractTerminalArrivalAreaSectorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FASDataBlock",
        "_type": "aixm:FASDataBlockType"
      },
      {
        "_name": "AbstractFASDataBlockExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "CirclingArea",
        "_type": "aixm:CirclingAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "CirclingAreaTimeSlice",
        "_type": "aixm:CirclingAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractCirclingAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "CirclingRestriction",
        "_type": "aixm:CirclingRestrictionType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractCirclingRestrictionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "EquipmentUnavailableAdjustment",
        "_type": "aixm:EquipmentUnavailableAdjustmentType"
      },
      {
        "_name": "AbstractEquipmentUnavailableAdjustmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "EquipmentUnavailableAdjustmentColumn",
        "_type": "aixm:EquipmentUnavailableAdjustmentColumnType"
      },
      {
        "_name": "AbstractEquipmentUnavailableAdjustmentColumnExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Minima",
        "_type": "aixm:MinimaType"
      },
      {
        "_name": "AbstractMinimaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandardInstrumentArrival",
        "_type": "aixm:StandardInstrumentArrivalType",
        "_substitutionGroup": "aixm:AbstractProcedure"
      },
      {
        "_name": "StandardInstrumentArrivalTimeSlice",
        "_type": "aixm:StandardInstrumentArrivalTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractStandardInstrumentArrivalExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DepartureArrivalCondition",
        "_type": "aixm:DepartureArrivalConditionType"
      },
      {
        "_name": "AbstractDepartureArrivalConditionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavigationArea",
        "_type": "aixm:NavigationAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "NavigationAreaTimeSlice",
        "_type": "aixm:NavigationAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractNavigationAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavigationAreaSector",
        "_type": "aixm:NavigationAreaSectorType"
      },
      {
        "_name": "AbstractNavigationAreaSectorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SectorDesign",
        "_type": "aixm:SectorDesignType"
      },
      {
        "_name": "AbstractSectorDesignExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandardInstrumentDeparture",
        "_type": "aixm:StandardInstrumentDepartureType",
        "_substitutionGroup": "aixm:AbstractProcedure"
      },
      {
        "_name": "StandardInstrumentDepartureTimeSlice",
        "_type": "aixm:StandardInstrumentDepartureTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractStandardInstrumentDepartureExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SafeAltitudeArea",
        "_type": "aixm:SafeAltitudeAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SafeAltitudeAreaTimeSlice",
        "_type": "aixm:SafeAltitudeAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSafeAltitudeAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SafeAltitudeAreaSector",
        "_type": "aixm:SafeAltitudeAreaSectorType"
      },
      {
        "_name": "AbstractSafeAltitudeAreaSectorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractApproachLeg",
        "_type": "aixm:AbstractApproachLegType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractSegmentLeg"
      },
      {
        "_name": "AbstractApproachLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ArrivalFeederLeg",
        "_type": "aixm:ArrivalFeederLegType",
        "_substitutionGroup": "aixm:AbstractApproachLeg"
      },
      {
        "_name": "ArrivalFeederLegTimeSlice",
        "_type": "aixm:ArrivalFeederLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractArrivalFeederLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ArrivalLeg",
        "_type": "aixm:ArrivalLegType",
        "_substitutionGroup": "aixm:AbstractSegmentLeg"
      },
      {
        "_name": "ArrivalLegTimeSlice",
        "_type": "aixm:ArrivalLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractArrivalLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DepartureLeg",
        "_type": "aixm:DepartureLegType",
        "_substitutionGroup": "aixm:AbstractSegmentLeg"
      },
      {
        "_name": "DepartureLegTimeSlice",
        "_type": "aixm:DepartureLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractDepartureLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FinalLeg",
        "_type": "aixm:FinalLegType",
        "_substitutionGroup": "aixm:AbstractApproachLeg"
      },
      {
        "_name": "FinalLegTimeSlice",
        "_type": "aixm:FinalLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractFinalLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "HoldingUse",
        "_type": "aixm:HoldingUseType"
      },
      {
        "_name": "AbstractHoldingUseExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "InitialLeg",
        "_type": "aixm:InitialLegType",
        "_substitutionGroup": "aixm:AbstractApproachLeg"
      },
      {
        "_name": "InitialLegTimeSlice",
        "_type": "aixm:InitialLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractInitialLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "IntermediateLeg",
        "_type": "aixm:IntermediateLegType",
        "_substitutionGroup": "aixm:AbstractApproachLeg"
      },
      {
        "_name": "IntermediateLegTimeSlice",
        "_type": "aixm:IntermediateLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractIntermediateLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "LandingTakeoffAreaCollection",
        "_type": "aixm:LandingTakeoffAreaCollectionType"
      },
      {
        "_name": "AbstractLandingTakeoffAreaCollectionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "MissedApproachLeg",
        "_type": "aixm:MissedApproachLegType",
        "_substitutionGroup": "aixm:AbstractApproachLeg"
      },
      {
        "_name": "MissedApproachLegTimeSlice",
        "_type": "aixm:MissedApproachLegTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractMissedApproachLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "NavigationAreaRestriction",
        "_type": "aixm:NavigationAreaRestrictionType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "NavigationAreaRestrictionTimeSlice",
        "_type": "aixm:NavigationAreaRestrictionTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractNavigationAreaRestrictionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractProcedure",
        "_type": "aixm:AbstractProcedureType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractProcedureExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ProcedureDME",
        "_type": "aixm:ProcedureDMEType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "ProcedureDMETimeSlice",
        "_type": "aixm:ProcedureDMETimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractProcedureDMEExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ProcedureTransition",
        "_type": "aixm:ProcedureTransitionType"
      },
      {
        "_name": "AbstractProcedureTransitionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ProcedureTransitionLeg",
        "_type": "aixm:ProcedureTransitionLegType"
      },
      {
        "_name": "AbstractProcedureTransitionLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractSegmentLeg",
        "_type": "aixm:AbstractSegmentLegType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractSegmentLegExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ProcedureAvailability",
        "_type": "aixm:ProcedureAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractProcedureAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ChangeOverPoint",
        "_type": "aixm:ChangeOverPointType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "ChangeOverPointTimeSlice",
        "_type": "aixm:ChangeOverPointTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractChangeOverPointExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Route",
        "_type": "aixm:RouteType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RouteTimeSlice",
        "_type": "aixm:RouteTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRouteExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RouteAvailability",
        "_type": "aixm:RouteAvailabilityType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractRouteAvailabilityExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RouteDME",
        "_type": "aixm:RouteDMEType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RouteDMETimeSlice",
        "_type": "aixm:RouteDMETimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRouteDMEExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RoutePortion",
        "_type": "aixm:RoutePortionType"
      },
      {
        "_name": "AbstractRoutePortionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RouteSegment",
        "_type": "aixm:RouteSegmentType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RouteSegmentTimeSlice",
        "_type": "aixm:RouteSegmentTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRouteSegmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceBorderCrossing",
        "_type": "aixm:AirspaceBorderCrossingType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AirspaceBorderCrossingTimeSlice",
        "_type": "aixm:AirspaceBorderCrossingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirspaceBorderCrossingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractDirectFlight",
        "_type": "aixm:AbstractDirectFlightType",
        "_abstract": "true"
      },
      {
        "_name": "AbstractDirectFlightExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DirectFlightClass",
        "_type": "aixm:DirectFlightClassType",
        "_substitutionGroup": "aixm:AbstractDirectFlight"
      },
      {
        "_name": "AbstractDirectFlightClassExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "DirectFlightSegment",
        "_type": "aixm:DirectFlightSegmentType",
        "_substitutionGroup": "aixm:AbstractDirectFlight"
      },
      {
        "_name": "AbstractDirectFlightSegmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightConditionCircumstance",
        "_type": "aixm:FlightConditionCircumstanceType"
      },
      {
        "_name": "AbstractFlightConditionCircumstanceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightConditionCombination",
        "_type": "aixm:FlightConditionCombinationType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractFlightConditionCombinationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightConditionElement",
        "_type": "aixm:FlightConditionElementType"
      },
      {
        "_name": "AbstractFlightConditionElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightRestriction",
        "_type": "aixm:FlightRestrictionType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "FlightRestrictionTimeSlice",
        "_type": "aixm:FlightRestrictionTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractFlightRestrictionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightRestrictionLevel",
        "_type": "aixm:FlightRestrictionLevelType"
      },
      {
        "_name": "AbstractFlightRestrictionLevelExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightRestrictionRoute",
        "_type": "aixm:FlightRestrictionRouteType"
      },
      {
        "_name": "AbstractFlightRestrictionRouteExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightRoutingElement",
        "_type": "aixm:FlightRoutingElementType"
      },
      {
        "_name": "AbstractFlightRoutingElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RulesProcedures",
        "_type": "aixm:RulesProceduresType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RulesProceduresTimeSlice",
        "_type": "aixm:RulesProceduresTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRulesProceduresExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AircraftGroundService",
        "_type": "aixm:AircraftGroundServiceType",
        "_substitutionGroup": "aixm:AbstractAirportGroundService"
      },
      {
        "_name": "AircraftGroundServiceTimeSlice",
        "_type": "aixm:AircraftGroundServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAircraftGroundServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportClearanceService",
        "_type": "aixm:AirportClearanceServiceType",
        "_substitutionGroup": "aixm:AbstractAirportGroundService"
      },
      {
        "_name": "AirportClearanceServiceTimeSlice",
        "_type": "aixm:AirportClearanceServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirportClearanceServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractAirportGroundService",
        "_type": "aixm:AbstractAirportGroundServiceType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractService"
      },
      {
        "_name": "AbstractAirportGroundServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirportSuppliesService",
        "_type": "aixm:AirportSuppliesServiceType",
        "_substitutionGroup": "aixm:AbstractAirportGroundService"
      },
      {
        "_name": "AirportSuppliesServiceTimeSlice",
        "_type": "aixm:AirportSuppliesServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirportSuppliesServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirTrafficControlService",
        "_type": "aixm:AirTrafficControlServiceType",
        "_substitutionGroup": "aixm:AbstractTrafficSeparationService"
      },
      {
        "_name": "AirTrafficControlServiceTimeSlice",
        "_type": "aixm:AirTrafficControlServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirTrafficControlServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirTrafficManagementService",
        "_type": "aixm:AirTrafficManagementServiceType",
        "_substitutionGroup": "aixm:AbstractService"
      },
      {
        "_name": "AirTrafficManagementServiceTimeSlice",
        "_type": "aixm:AirTrafficManagementServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractAirTrafficManagementServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "CallsignDetail",
        "_type": "aixm:CallsignDetailType"
      },
      {
        "_name": "AbstractCallsignDetailExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FireFightingService",
        "_type": "aixm:FireFightingServiceType",
        "_substitutionGroup": "aixm:AbstractAirportGroundService"
      },
      {
        "_name": "FireFightingServiceTimeSlice",
        "_type": "aixm:FireFightingServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractFireFightingServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Fuel",
        "_type": "aixm:FuelType"
      },
      {
        "_name": "AbstractFuelExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "GroundTrafficControlService",
        "_type": "aixm:GroundTrafficControlServiceType",
        "_substitutionGroup": "aixm:AbstractTrafficSeparationService"
      },
      {
        "_name": "GroundTrafficControlServiceTimeSlice",
        "_type": "aixm:GroundTrafficControlServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractGroundTrafficControlServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "InformationService",
        "_type": "aixm:InformationServiceType",
        "_substitutionGroup": "aixm:AbstractService"
      },
      {
        "_name": "InformationServiceTimeSlice",
        "_type": "aixm:InformationServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractInformationServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Nitrogen",
        "_type": "aixm:NitrogenType"
      },
      {
        "_name": "AbstractNitrogenExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Oil",
        "_type": "aixm:OilType"
      },
      {
        "_name": "AbstractOilExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Oxygen",
        "_type": "aixm:OxygenType"
      },
      {
        "_name": "AbstractOxygenExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PassengerService",
        "_type": "aixm:PassengerServiceType",
        "_substitutionGroup": "aixm:AbstractAirportGroundService"
      },
      {
        "_name": "PassengerServiceTimeSlice",
        "_type": "aixm:PassengerServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractPassengerServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PilotControlledLighting",
        "_type": "aixm:PilotControlledLightingType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "PilotControlledLightingTimeSlice",
        "_type": "aixm:PilotControlledLightingTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractPilotControlledLightingExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RadioCommunicationChannel",
        "_type": "aixm:RadioCommunicationChannelType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RadioCommunicationChannelTimeSlice",
        "_type": "aixm:RadioCommunicationChannelTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRadioCommunicationChannelExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RadioCommunicationOperationalStatus",
        "_type": "aixm:RadioCommunicationOperationalStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractRadioCommunicationOperationalStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SearchRescueService",
        "_type": "aixm:SearchRescueServiceType",
        "_substitutionGroup": "aixm:AbstractService"
      },
      {
        "_name": "SearchRescueServiceTimeSlice",
        "_type": "aixm:SearchRescueServiceTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSearchRescueServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractService",
        "_type": "aixm:AbstractServiceType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ServiceOperationalStatus",
        "_type": "aixm:ServiceOperationalStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractServiceOperationalStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractTrafficSeparationService",
        "_type": "aixm:AbstractTrafficSeparationServiceType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractService"
      },
      {
        "_name": "AbstractTrafficSeparationServiceExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ContactInformation",
        "_type": "aixm:ContactInformationType"
      },
      {
        "_name": "AbstractContactInformationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "OnlineContact",
        "_type": "aixm:OnlineContactType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractOnlineContactExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PostalAddress",
        "_type": "aixm:PostalAddressType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractPostalAddressExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "TelephoneContact",
        "_type": "aixm:TelephoneContactType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractTelephoneContactExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AircraftCharacteristic",
        "_type": "aixm:AircraftCharacteristicType"
      },
      {
        "_name": "AbstractAircraftCharacteristicExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "FlightCharacteristic",
        "_type": "aixm:FlightCharacteristicType"
      },
      {
        "_name": "AbstractFlightCharacteristicExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AirspaceLayer",
        "_type": "aixm:AirspaceLayerType"
      },
      {
        "_name": "AbstractAirspaceLayerExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "CircleSector",
        "_type": "aixm:CircleSectorType"
      },
      {
        "_name": "AbstractCircleSectorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "LightElement",
        "_type": "aixm:LightElementType"
      },
      {
        "_name": "AbstractLightElementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "LightElementStatus",
        "_type": "aixm:LightElementStatusType",
        "_substitutionGroup": "aixm:AbstractPropertiesWithSchedule"
      },
      {
        "_name": "AbstractLightElementStatusExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Meteorology",
        "_type": "aixm:MeteorologyType"
      },
      {
        "_name": "AbstractMeteorologyExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RadioFrequencyArea",
        "_type": "aixm:RadioFrequencyAreaType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RadioFrequencyAreaTimeSlice",
        "_type": "aixm:RadioFrequencyAreaTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRadioFrequencyAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractPropertiesWithSchedule",
        "_type": "aixm:AbstractPropertiesWithScheduleType",
        "_abstract": "true"
      },
      {
        "_name": "AbstractPropertiesWithScheduleExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SpecialDate",
        "_type": "aixm:SpecialDateType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "SpecialDateTimeSlice",
        "_type": "aixm:SpecialDateTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSpecialDateExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Timesheet",
        "_type": "aixm:TimesheetType"
      },
      {
        "_name": "AbstractTimesheetExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandardLevel",
        "_type": "aixm:StandardLevelType"
      },
      {
        "_name": "AbstractStandardLevelExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandardLevelColumn",
        "_type": "aixm:StandardLevelColumnType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "StandardLevelColumnTimeSlice",
        "_type": "aixm:StandardLevelColumnTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractStandardLevelColumnExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandardLevelSector",
        "_type": "aixm:StandardLevelSectorType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "StandardLevelSectorTimeSlice",
        "_type": "aixm:StandardLevelSectorTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractStandardLevelSectorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "StandardLevelTable",
        "_type": "aixm:StandardLevelTableType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "StandardLevelTableTimeSlice",
        "_type": "aixm:StandardLevelTableTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractStandardLevelTableExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AltitudeAdjustment",
        "_type": "aixm:AltitudeAdjustmentType"
      },
      {
        "_name": "AbstractAltitudeAdjustmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "HoldingAssessment",
        "_type": "aixm:HoldingAssessmentType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "HoldingAssessmentTimeSlice",
        "_type": "aixm:HoldingAssessmentTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractHoldingAssessmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ObstacleAssessmentArea",
        "_type": "aixm:ObstacleAssessmentAreaType"
      },
      {
        "_name": "AbstractObstacleAssessmentAreaExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "ObstaclePlacement",
        "_type": "aixm:ObstaclePlacementType"
      },
      {
        "_name": "AbstractObstaclePlacementExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Obstruction",
        "_type": "aixm:ObstructionType"
      },
      {
        "_name": "AbstractObstructionExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PrecisionApproachRadar",
        "_type": "aixm:PrecisionApproachRadarType",
        "_substitutionGroup": "aixm:AbstractRadarEquipment"
      },
      {
        "_name": "PrecisionApproachRadarTimeSlice",
        "_type": "aixm:PrecisionApproachRadarTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractPrecisionApproachRadarExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "PrimarySurveillanceRadar",
        "_type": "aixm:PrimarySurveillanceRadarType",
        "_substitutionGroup": "aixm:AbstractSurveillanceRadar"
      },
      {
        "_name": "PrimarySurveillanceRadarTimeSlice",
        "_type": "aixm:PrimarySurveillanceRadarTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractPrimarySurveillanceRadarExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RadarComponent",
        "_type": "aixm:RadarComponentType"
      },
      {
        "_name": "AbstractRadarComponentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractRadarEquipment",
        "_type": "aixm:AbstractRadarEquipmentType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "AbstractRadarEquipmentExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "RadarSystem",
        "_type": "aixm:RadarSystemType",
        "_substitutionGroup": "aixm:AbstractAIXMFeature"
      },
      {
        "_name": "RadarSystemTimeSlice",
        "_type": "aixm:RadarSystemTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractRadarSystemExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "Reflector",
        "_type": "aixm:ReflectorType"
      },
      {
        "_name": "AbstractReflectorExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SecondarySurveillanceRadar",
        "_type": "aixm:SecondarySurveillanceRadarType",
        "_substitutionGroup": "aixm:AbstractSurveillanceRadar"
      },
      {
        "_name": "SecondarySurveillanceRadarTimeSlice",
        "_type": "aixm:SecondarySurveillanceRadarTimeSliceType",
        "_substitutionGroup": "gml:AbstractTimeSlice"
      },
      {
        "_name": "AbstractSecondarySurveillanceRadarExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "SurveillanceGroundStation",
        "_type": "aixm:SurveillanceGroundStationType"
      },
      {
        "_name": "AbstractSurveillanceGroundStationExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      },
      {
        "_name": "AbstractSurveillanceRadar",
        "_type": "aixm:AbstractSurveillanceRadarType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractRadarEquipment"
      },
      {
        "_name": "AbstractSurveillanceRadarExtension",
        "_type": "aixm:AbstractExtensionType",
        "_abstract": "true",
        "_substitutionGroup": "aixm:AbstractExtension"
      }
    ],
    "group": [
      {
        "sequence": {
          "element": [
            {
              "_name": "designatorPrefix",
              "_type": "aixm:CodeAerialRefuellingPrefixType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorNumber",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorSuffix",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorDirection",
              "_type": "aixm:CodeCardinalDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeAerialRefuellingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "radarBeaconSetting",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "xbandRadarSetting",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "tankerChannel",
              "_type": "aixm:CodeTACANChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "receiverChannel",
              "_type": "aixm:CodeTACANChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "helicopterRoute",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "specialRefuelling",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "bidirectionalUse",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "reverseDirectionTurn",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "availability",
              "_type": "aixm:RouteAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "protectingAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "track",
              "_type": "aixm:AerialRefuellingTrackPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "anchor",
              "_type": "aixm:AerialRefuellingAnchorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "oppositeTrack",
              "_type": "aixm:AerialRefuellingPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "managingOrganisation",
              "_type": "aixm:AuthorityForAerialRefuellingPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AerialRefuellingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "outboundCourse",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "outboundCourseType",
              "_type": "aixm:CodeCourseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "inboundCourse",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turnDirection",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedLimit",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "legSeparation",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "legLength",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "refuellingBaseLevel",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "refuellingBaseLevelReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "extent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "verticalExtent",
              "_type": "aixm:AirspaceLayerPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "point",
              "_type": "aixm:AerialRefuellingPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AerialRefuellingAnchorPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "sequence",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usageType",
              "_type": "aixm:CodeAerialRefuellingPointType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AerialRefuellingPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "extent",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "point",
              "_type": "aixm:AerialRefuellingPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "verticalExtent",
              "_type": "aixm:AirspaceLayerPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AerialRefuellingTrackPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAuthorityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AuthorityForAerialRefuellingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:CodeAirportHeliportDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "locationIndicatorICAO",
              "_type": "aixm:CodeICAOType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorIATA",
              "_type": "aixm:CodeIATAType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeAirportHeliportType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "certifiedICAO",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "privateUse",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "controlType",
              "_type": "aixm:CodeMilitaryOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "fieldElevation",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "fieldElevationAccuracy",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalDatum",
              "_type": "aixm:CodeVerticalDatumType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariation",
              "_type": "aixm:ValMagneticVariationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariationAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dateMagneticVariation",
              "_type": "aixm:DateYearType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariationChange",
              "_type": "aixm:ValMagneticVariationChangeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "referenceTemperature",
              "_type": "aixm:ValTemperatureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altimeterCheckLocation",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "secondaryPowerSupply",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "windDirectionIndicator",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "landingDirectionIndicator",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "transitionAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "transitionLevel",
              "_type": "aixm:ValFLType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowestTemperature",
              "_type": "aixm:ValTemperatureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "abandoned",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "certificationDate",
              "_type": "aixm:DateType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "certificationExpirationDate",
              "_type": "aixm:DateType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "contaminant",
              "_type": "aixm:AirportHeliportContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "servedCity",
              "_type": "aixm:CityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "responsibleOrganisation",
              "_type": "aixm:AirportHeliportResponsibilityOrganisationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "ARP",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "aviationBoundary",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "altimeterSource",
              "_type": "aixm:AltimeterSourcePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "contact",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:AirportHeliportAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirportHeliportPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "operationalStatus",
              "_type": "aixm:CodeStatusAirportType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "warning",
              "_type": "aixm:CodeAirportWarningType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usage",
              "_type": "aixm:AirportHeliportUsagePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirportHeliportAvailabilityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAirportHeliportCollocationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "hostAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "dependentAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirportHeliportCollocationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lighting",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "obstacleFree",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirportHeliportProtectionAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "role",
              "_type": "aixm:CodeAuthorityRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "theOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AirportHeliportResponsibilityOrganisationPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operation",
            "_type": "aixm:CodeOperationAirportHeliportType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "AirportHeliportUsagePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "area",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "affectedAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirportHotSpotPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "isRemote",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "isPrimary",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "availability",
              "_type": "aixm:AltimeterSourceStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AltimeterSourcePropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operationalStatus",
            "_type": "aixm:CodeStatusOperationsType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "AltimeterSourceStatusPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "CityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "logicalOperator",
              "_type": "aixm:CodeLogicalOperatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "weather",
              "_type": "aixm:MeteorologyPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "aircraft",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "flight",
              "_type": "aixm:FlightCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "subCondition",
              "_type": "aixm:ConditionCombinationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ConditionCombinationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NonMovementAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "composition",
              "_type": "aixm:CodeSurfaceCompositionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "preparation",
              "_type": "aixm:CodeSurfacePreparationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceCondition",
              "_type": "aixm:CodeSurfaceConditionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "classPCN",
              "_type": "aixm:ValPCNType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "pavementTypePCN",
              "_type": "aixm:CodePCNPavementType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "pavementSubgradePCN",
              "_type": "aixm:CodePCNSubgradeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maxTyrePressurePCN",
              "_type": "aixm:CodePCNTyrePressureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "evaluationMethodPCN",
              "_type": "aixm:CodePCNMethodType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "classLCN",
              "_type": "aixm:ValLCNType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "weightSIWL",
              "_type": "aixm:ValWeightType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "tyrePressureSIWL",
              "_type": "aixm:ValPressureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "weightAUW",
              "_type": "aixm:ValWeightType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SurfaceCharacteristicsPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SurveyControlPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeUsageLimitationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "priorPermission",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "contact",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "selection",
              "_type": "aixm:ConditionCombinationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "UsageConditionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeWorkAreaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "plannedOperational",
              "_type": "aixm:DateType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "activation",
              "_type": "aixm:WorkareaActivityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "WorkAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "isActive",
            "_type": "aixm:CodeYesNoType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "WorkareaActivityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeAircraftStandType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "visualDockingSystem",
              "_type": "aixm:CodeVisualDockingGuidanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "apronLocation",
              "_type": "aixm:ApronElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "contaminant",
              "_type": "aixm:AircraftStandContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ApronAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AircraftStandPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "abandoned",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "contaminant",
              "_type": "aixm:ApronContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ApronAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApronPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "operationalStatus",
              "_type": "aixm:CodeStatusAirportType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "warning",
              "_type": "aixm:CodeAirportWarningType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usage",
              "_type": "aixm:ApronAreaUsagePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApronAreaAvailabilityPropertyGroup"
      },
      {
        "sequence": "",
        "_name": "ApronAreaUsagePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeApronElementType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "jetwayAvailability",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "towingAvailability",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dockingAvailability",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "groundPowerAvailability",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedApron",
              "_type": "aixm:ApronPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "supplyService",
              "_type": "aixm:AirportSuppliesServicePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ApronAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApronElementPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "associatedApron",
              "_type": "aixm:ApronPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "taxiwayLocation",
              "_type": "aixm:TaxiwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "standLocation",
              "_type": "aixm:AircraftStandPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ApronAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "DeicingAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeLoadingBridgeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedStand",
              "_type": "aixm:AircraftStandPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "PassengerLoadingBridgePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeStatusOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeRoadType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "abandoned",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "accessibleStand",
              "_type": "aixm:AircraftStandPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "surfaceExtent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RoadPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slope",
              "_type": "aixm:ValSlopeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "helicopterClass",
              "_type": "aixm:CodeHelicopterPerformanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "abandoned",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "aimingPoint",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "approachTakeOffArea",
              "_type": "aixm:RunwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "contaminant",
              "_type": "aixm:TouchDownLiftOffContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ManoeuvringAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "TouchDownLiftOffPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportHeliportProtectionAreaPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "protectedTouchDownLiftOff",
            "_type": "aixm:TouchDownLiftOffPropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "TouchDownLiftOffSafeAreaPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "classICAO",
              "_type": "aixm:CodeApproachLightingICAOType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeApproachLightingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "sequencedFlashing",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "alignmentIndicator",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "servedRunwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "ApproachLightingSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "position",
              "_type": "aixm:CodeApronSectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lightedApron",
              "_type": "aixm:ApronPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "ApronLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operationalStatus",
            "_type": "aixm:CodeStatusOperationsType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "GroundLightingAvailabilityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "emergencyLighting",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "intensityLevel",
              "_type": "aixm:CodeLightIntensityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "colour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "element",
              "_type": "aixm:LightElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:GroundLightingAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "GroundLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "lightedGuidanceLine",
            "_type": "aixm:GuidanceLinePropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "GuidanceLineLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "clicks",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "intensityLevel",
              "_type": "aixm:CodeLightIntensityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "activation",
              "_type": "aixm:CodeSystemActivationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "LightActivationPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "position",
              "_type": "aixm:CodeRunwaySectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedRunwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "RunwayDirectionLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "position",
              "_type": "aixm:CodeProtectAreaSectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lightedArea",
              "_type": "aixm:RunwayProtectAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "RunwayProtectAreaLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeLightHoldingPositionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "taxiHolding",
              "_type": "aixm:TaxiHoldingPositionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "TaxiHoldingPositionLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "position",
              "_type": "aixm:CodeTaxiwaySectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lightedTaxiway",
              "_type": "aixm:TaxiwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "TaxiwayLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "position",
              "_type": "aixm:CodeTLOFSectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lightedTouchDownLiftOff",
              "_type": "aixm:TouchDownLiftOffPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "TouchDownLiftOffLightSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "markingLocation",
              "_type": "aixm:CodeProtectAreaSectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markedProtectionArea",
              "_type": "aixm:AirportHeliportProtectionAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "AirportProtectionAreaMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "markingLocation",
              "_type": "aixm:CodeApronSectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markedApron",
              "_type": "aixm:ApronPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "ApronMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "markedDeicingArea",
            "_type": "aixm:DeicingAreaPropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "DeicingAreaMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "markedGuidanceLine",
            "_type": "aixm:GuidanceLinePropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "GuidanceLineMarkingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "markingICAOStandard",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "condition",
              "_type": "aixm:CodeMarkingConditionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "element",
              "_type": "aixm:MarkingElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "MarkingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "colour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "style",
              "_type": "aixm:CodeMarkingStyleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "extent_curveExtent",
                "_type": "aixm:ElevatedCurvePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "extent_surfaceExtent",
                "_type": "aixm:ElevatedSurfacePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "extent_location",
                "_type": "aixm:ElevatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "MarkingElementPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "markingLocation",
              "_type": "aixm:CodeRunwaySectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markedRunway",
              "_type": "aixm:RunwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "RunwayMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "markedStand",
            "_type": "aixm:AircraftStandPropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "StandMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "markedTaxiHold",
            "_type": "aixm:TaxiHoldingPositionPropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "TaxiHoldingPositionMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "markingLocation",
              "_type": "aixm:CodeTaxiwaySectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markedTaxiway",
              "_type": "aixm:TaxiwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "markedElement",
              "_type": "aixm:TaxiwayElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "TaxiwayMarkingPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:MarkingPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "markingLocation",
              "_type": "aixm:CodeTLOFSectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markedTouchDownLiftOff",
              "_type": "aixm:TouchDownLiftOffPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "TouchDownLiftOffMarkingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "status",
              "_type": "aixm:CodeStatusOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "engageDevice",
              "_type": "aixm:CodeArrestingGearEngageDeviceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "absorbType",
              "_type": "aixm:CodeArrestingGearEnergyAbsorbType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "bidirectional",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "runwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "extent_surfaceExtent",
                "_type": "aixm:ElevatedSurfacePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "extent_curveExtent",
                "_type": "aixm:ElevatedCurvePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "extent_pointExtent",
                "_type": "aixm:ElevatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "ArrestingGearPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "operationalStatus",
              "_type": "aixm:CodeStatusAirportType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "warning",
              "_type": "aixm:CodeAirportWarningType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usage",
              "_type": "aixm:ManoeuvringAreaUsagePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ManoeuvringAreaAvailabilityPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operation",
            "_type": "aixm:CodeOperationManoeuvringAreaType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "ManoeuvringAreaUsagePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "distanceAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theNavaidEquipment",
              "_type": "aixm:NavaidEquipmentPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "NavaidEquipmentDistancePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeRunwayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "nominalLength",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lengthAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "nominalWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthShoulder",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lengthStrip",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthStrip",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lengthOffset",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthOffset",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "abandoned",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "overallContaminant",
              "_type": "aixm:RunwayContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "areaContaminant",
              "_type": "aixm:RunwaySectionContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeStatusOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usedRunwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayBlastPadPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "role",
              "_type": "aixm:CodeRunwayPointRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "onRunway",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedDeclaredDistance",
              "_type": "aixm:RunwayDeclaredDistancePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "navaidEquipment",
              "_type": "aixm:NavaidEquipmentDistancePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayCentrelinePointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeDeclaredDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "declaredValue",
              "_type": "aixm:RunwayDeclaredDistanceValuePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayDeclaredDistancePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "distanceAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "RunwayDeclaredDistanceValuePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearingAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "patternVFR",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slopeTDZ",
              "_type": "aixm:ValSlopeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "elevationTDZ",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "elevationTDZAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "approachMarkingType",
              "_type": "aixm:CodeRunwayMarkingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "approachMarkingCondition",
              "_type": "aixm:CodeMarkingConditionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "classLightingJAR",
              "_type": "aixm:CodeLightingJARType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "precisionApproachGuidance",
              "_type": "aixm:CodeApproachGuidanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usedRunway",
              "_type": "aixm:RunwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "startingElement",
              "_type": "aixm:RunwayElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ManoeuvringAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayDirectionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeRunwayElementType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "gradeSeparation",
              "_type": "aixm:CodeGradeSeparationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedRunway",
              "_type": "aixm:RunwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ManoeuvringAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayElementPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportHeliportProtectionAreaPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeRunwayProtectionAreaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeStatusOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "protectedRunwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "RunwayProtectAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "readingPosition",
              "_type": "aixm:CodeRVRReadingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedRunwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RunwayVisualRangePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:GroundLightSystemPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeVASISType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "position",
              "_type": "aixm:CodeSideType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "numberBox",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "portable",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slopeAngle",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumEyeHeightOverThreshold",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "runwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "VisualGlideSlopeIndicatorPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FloatingDockSitePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:CodeBuoyDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeBuoyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "colour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "theSeaplaneLandingArea",
              "_type": "aixm:SeaplaneLandingAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "MarkingBuoyPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "rampSite",
              "_type": "aixm:SeaplaneRampSitePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "dockSite",
              "_type": "aixm:FloatingDockSitePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ManoeuvringAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SeaplaneLandingAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "centreline",
              "_type": "aixm:ElevatedCurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SeaplaneRampSitePropertyGroup"
      },
      {
        "sequence": "",
        "_name": "AircraftStandContaminationPropertyGroup"
      },
      {
        "sequence": "",
        "_name": "AirportHeliportContaminationPropertyGroup"
      },
      {
        "sequence": "",
        "_name": "ApronContaminationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "side",
              "_type": "aixm:CodeSideType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "depth",
              "_type": "aixm:ValDepthType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RidgePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "clearedLength",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clearedWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clearedSide",
              "_type": "aixm:CodeSideType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "furtherClearanceLength",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "furtherClearanceWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "obscuredLightsSide",
              "_type": "aixm:CodeSideType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clearedLengthBegin",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "taxiwayAvailable",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "apronAvailable",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "RunwayContaminationPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "section",
            "_type": "aixm:CodeRunwaySectionType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "RunwaySectionContaminationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "observationTime",
              "_type": "aixm:DateTimeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "depth",
              "_type": "aixm:ValDepthType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frictionCoefficient",
              "_type": "aixm:ValFrictionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frictionEstimation",
              "_type": "aixm:CodeFrictionEstimateType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frictionDevice",
              "_type": "aixm:CodeFrictionDeviceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "obscuredLights",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "furtherClearanceTime",
              "_type": "aixm:TimeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "furtherTotalClearance",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "nextObservationTime",
              "_type": "aixm:DateTimeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "proportion",
              "_type": "aixm:ValPercentType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "criticalRidge",
              "_type": "aixm:RidgePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "layer",
              "_type": "aixm:SurfaceContaminationLayerPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SurfaceContaminationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "layerOrder",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeContaminationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SurfaceContaminationLayerPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "clearedWidth",
            "_type": "aixm:ValDistanceType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "TaxiwayContaminationPropertyGroup"
      },
      {
        "sequence": "",
        "_name": "TouchDownLiftOffContaminationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeGuidanceLineType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maxSpeed",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "usageDirection",
              "_type": "aixm:CodeDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "connectedTouchDownLiftOff",
              "_type": "aixm:TouchDownLiftOffPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "connectedRunwayCentrelinePoint",
              "_type": "aixm:RunwayCentrelinePointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "connectedApron",
              "_type": "aixm:ApronPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "connectedStand",
              "_type": "aixm:AircraftStandPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedCurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "connectedTaxiway",
              "_type": "aixm:TaxiwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "GuidanceLinePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "landingCategory",
              "_type": "aixm:CodeHoldingCategoryType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeStatusOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedGuidanceLine",
              "_type": "aixm:GuidanceLinePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "protectedRunway",
              "_type": "aixm:RunwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "TaxiHoldingPositionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeTaxiwayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthShoulder",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "abandoned",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedAirportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "contaminant",
              "_type": "aixm:TaxiwayContaminationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ManoeuvringAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "TaxiwayPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeTaxiwayElementType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "gradeSeparation",
              "_type": "aixm:CodeGradeSeparationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceProperties",
              "_type": "aixm:SurfaceCharacteristicsPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "associatedTaxiway",
              "_type": "aixm:TaxiwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:ElevatedSurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ManoeuvringAreaAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "TaxiwayElementPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAirspaceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:CodeAirspaceDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "localType",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorICAO",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "controlType",
              "_type": "aixm:CodeMilitaryOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLowerSeparation",
              "_type": "aixm:ValFLType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "class",
              "_type": "aixm:AirspaceLayerClassPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "protectedRoute",
              "_type": "aixm:RoutePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "geometryComponent",
              "_type": "aixm:AirspaceGeometryComponentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "activation",
              "_type": "aixm:AirspaceActivationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirspacePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "activity",
              "_type": "aixm:CodeAirspaceActivityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeStatusAirspaceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "levels",
              "_type": "aixm:AirspaceLayerPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "user",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "aircraft",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirspaceActivationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "operation",
              "_type": "aixm:CodeAirspaceAggregationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "operationSequence",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theAirspaceVolume",
              "_type": "aixm:AirspaceVolumePropertyType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AirspaceGeometryComponentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "classification",
              "_type": "aixm:CodeAirspaceClassificationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "associatedLevels",
              "_type": "aixm:AirspaceLayerPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirspaceLayerClassPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maximumLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maximumLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "horizontalProjection",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "centreline",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "contributorAirspace",
              "_type": "aixm:AirspaceVolumeDependencyPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirspaceVolumePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "dependency",
              "_type": "aixm:CodeAirspaceDependencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AirspaceVolumeDependencyPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAuthorityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "responsibleOrganisation",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "assignedAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AuthorityForAirspacePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeGeoBorderType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "border",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "GeoBorderPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "horizontalAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "CurvePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "elevation",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "geoidUndulation",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalDatum",
              "_type": "aixm:CodeVerticalDatumType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "ElevatedCurvePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "elevation",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "geoidUndulation",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalDatum",
              "_type": "aixm:CodeVerticalDatumType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "ElevatedPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "elevation",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "geoidUndulation",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalDatum",
              "_type": "aixm:CodeVerticalDatumType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "ElevatedSurfacePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "horizontalAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "PointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "horizontalAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SurfacePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeHoldingUsageType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "outboundCourse",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "outboundCourseType",
              "_type": "aixm:CodeCourseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "inboundCourse",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turnDirection",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedLimit",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "nonStandardHolding",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "holdingPoint",
              "_type": "aixm:SegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "outboundLegSpan_endPoint",
                "_type": "aixm:SegmentPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "outboundLegSpan_endDistance",
                "_type": "aixm:HoldingPatternDistancePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "outboundLegSpan_endTime",
                "_type": "aixm:HoldingPatternDurationPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "HoldingPatternPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "HoldingPatternDistancePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "duration",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "HoldingPatternDurationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "unplannedHolding",
              "_type": "aixm:CodeApprovalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "authorizedAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "controlledAirspace",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "holdingPoint",
              "_type": "aixm:SegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "UnplannedHoldingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAuthorityRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AuthorityForNavaidEquipmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAuthorityRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AuthorityForSpecialNavigationStationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAuthorityRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AuthorityForSpecialNavigationSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeMLSAzimuthType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearingAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleProportionalLeft",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleProportionalRight",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleCoverLeft",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleCoverRight",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "channel",
              "_type": "aixm:CodeMLSChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AzimuthPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavigationSystemCheckpointPropertyGroup",
            "_minOccurs": "0"
          }
        },
        "_name": "CheckpointINSPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavigationSystemCheckpointPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "checkPointFacility",
            "_type": "aixm:VORPropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "CheckpointVORPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "doppler",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "informationProvision",
              "_type": "aixm:InformationServicePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "DirectionFinderPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeDMEType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "channel",
              "_type": "aixm:CodeDMEChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "ghostFrequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "displace",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "DMEPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "angleNominal",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleMinimum",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleSpan",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "ElevationPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slope",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rdh",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rdhAccuracy",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "GlidepathPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticBearingAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearingAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "declination",
              "_type": "aixm:ValMagneticVariationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthCourse",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthCourseAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "backCourseUsable",
              "_type": "aixm:CodeILSBackCourseType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "LocalizerPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "class",
              "_type": "aixm:CodeMarkerBeaconSignalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "axisBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "auralMorseCode",
              "_type": "aixm:CodeAuralMorseType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "MarkerBeaconPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeNavaidServiceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:CodeNavaidDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flightChecked",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "purpose",
              "_type": "aixm:CodeNavaidPurposeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "signalPerformance",
              "_type": "aixm:CodeSignalPerformanceILSType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseQuality",
              "_type": "aixm:CodeCourseQualityILSType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "integrityLevel",
              "_type": "aixm:CodeIntegrityLevelILSType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "touchDownLiftOff",
              "_type": "aixm:TouchDownLiftOffPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "navaidEquipment",
              "_type": "aixm:NavaidComponentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "runwayDirection",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "servedAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:NavaidOperationalStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NavaidPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "collocationGroup",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markerPosition",
              "_type": "aixm:CodePositionInILSType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "providesNavigableLocation",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theNavaidEquipment",
              "_type": "aixm:NavaidEquipmentPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "NavaidComponentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:CodeNavaidDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "emissionClass",
              "_type": "aixm:CodeRadioEmissionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "mobile",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariation",
              "_type": "aixm:ValMagneticVariationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariationAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dateMagneticVariation",
              "_type": "aixm:DateYearType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flightChecked",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "authority",
              "_type": "aixm:AuthorityForNavaidEquipmentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "monitoring",
              "_type": "aixm:NavaidEquipmentMonitoringPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:NavaidOperationalStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NavaidEquipmentPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "monitored",
            "_type": "aixm:CodeYesNoType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "NavaidEquipmentMonitoringPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "operationalStatus",
              "_type": "aixm:CodeStatusNavaidType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "signalType",
              "_type": "aixm:CodeRadioSignalType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "NavaidOperationalStatusPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "category",
              "_type": "aixm:CodeCheckpointCategoryType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeInterpretation",
              "_type": "aixm:CodeAltitudeUseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angle",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "position",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "airportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NavigationSystemCheckpointPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "class",
              "_type": "aixm:CodeNDBUsageType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "emissionBand",
              "_type": "aixm:CodeEmissionBandType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "NDBPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "SDFPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeSpecialNavigationStationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "emission",
              "_type": "aixm:CodeRadioEmissionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "systemChain",
              "_type": "aixm:SpecialNavigationSystemPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "responsibleOrganisation",
              "_type": "aixm:AuthorityForSpecialNavigationStationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "position",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "availability",
              "_type": "aixm:SpecialNavigationStationStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SpecialNavigationStationPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operationalStatus",
            "_type": "aixm:CodeStatusNavaidType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "SpecialNavigationStationStatusPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeSpecialNavigationSystemType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:CodeSpecialNavigationChainDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "responsibleOrganisation",
              "_type": "aixm:AuthorityForSpecialNavigationSystemPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SpecialNavigationSystemPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "channel",
              "_type": "aixm:CodeTACANChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "declination",
              "_type": "aixm:ValMagneticVariationType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "TACANPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:NavaidEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeVORType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "zeroBearingDirection",
              "_type": "aixm:CodeNorthReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "declination",
              "_type": "aixm:ValMagneticVariationType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "VORPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "angle",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleType",
              "_type": "aixm:CodeBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "indicationDirection",
              "_type": "aixm:CodeDirectionReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueAngle",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "cardinalDirection",
              "_type": "aixm:CodeCardinalDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumReceptionAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "fix",
              "_type": "aixm:DesignatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "pointChoice_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "AngleIndicationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "alongCourseGuidance",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theAngleIndication",
              "_type": "aixm:AngleIndicationPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "AngleUsePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumReceptionAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeDistanceIndicationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "fix",
              "_type": "aixm:DesignatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "pointChoice_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "DistanceIndicationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "roleFreeFlight",
              "_type": "aixm:CodeFreeFlightType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "roleRVSM",
              "_type": "aixm:CodeRVSMPointRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turnRadius",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "roleMilitaryTraining",
              "_type": "aixm:CodeMilitaryRoutePointType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "EnRouteSegmentPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "role",
              "_type": "aixm:CodeReferenceRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "priorFixTolerance",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "postFixTolerance",
              "_type": "aixm:ValDistanceSignedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "point",
              "_type": "aixm:DesignatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "facilityAngle",
              "_type": "aixm:AngleUsePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "facilityDistance",
              "_type": "aixm:DistanceIndicationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "fixToleranceArea",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "PointReferencePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "reportingATC",
              "_type": "aixm:CodeATCReportingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flyOver",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "waypoint",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "radarGuidance",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "facilityMakeup",
              "_type": "aixm:PointReferencePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "extendedServiceVolume",
              "_type": "aixm:RadioFrequencyAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "pointChoice_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "pointChoice_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "SegmentPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "role",
              "_type": "aixm:CodeProcedureFixRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "leadRadial",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "leadDME",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "indicatorFACF",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "TerminalSegmentPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:CodeDesignatedPointDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeDesignatedPointType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:PointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "aimingPoint",
              "_type": "aixm:TouchDownLiftOffPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "airportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "runwayPoint",
              "_type": "aixm:RunwayCentrelinePointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "DesignatedPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAirspacePointRoleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "relativeLocation",
              "_type": "aixm:CodeAirspacePointPositionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "containingAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "location_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "SignificantPointInAirspacePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeGroundLightingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "colour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flashing",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "structureBeacon",
              "_type": "aixm:VerticalStructurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "aerodromeBeacon",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AeronauticalGroundLightPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "note",
            "_type": "aixm:TextNoteType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "LinguisticNotePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "propertyName",
              "_type": "aixm:TextPropertyNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "purpose",
              "_type": "aixm:CodeNotePurposeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "translatedNote",
              "_type": "aixm:LinguisticNotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NotePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeObstacleAreaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "obstructionIdSurfaceCondition",
              "_type": "aixm:CodeObstacleAssessmentSurfaceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceExtent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "obstacle",
              "_type": "aixm:VerticalStructurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "reference_ownerOrganisation",
                "_type": "aixm:OrganisationAuthorityPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "reference_ownerRunway",
                "_type": "aixm:RunwayDirectionPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "reference_ownerAirport",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "ObstacleAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeVerticalStructureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lighted",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markingICAOStandard",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "group",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "width",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "radius",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lightingICAOStandard",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "synchronisedLighting",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "marker",
              "_type": "aixm:MarkerBeaconPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "part",
              "_type": "aixm:VerticalStructurePartPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "hostedPassengerService",
              "_type": "aixm:PassengerServicePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "supportedGroundLight",
              "_type": "aixm:GroundLightSystemPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "hostedNavaidEquipment",
              "_type": "aixm:NavaidEquipmentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "hostedSpecialNavStation",
              "_type": "aixm:SpecialNavigationStationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "hostedUnit",
              "_type": "aixm:UnitPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "hostedOrganisation",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "supportedService",
              "_type": "aixm:ServicePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "lightingAvailability",
              "_type": "aixm:VerticalStructureLightingStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "VerticalStructurePropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "status",
            "_type": "aixm:CodeStatusOperationsType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "VerticalStructureLightingStatusPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "verticalExtent",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalExtentAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeVerticalStructureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "constructionStatus",
              "_type": "aixm:CodeStatusConstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markingPattern",
              "_type": "aixm:CodeVerticalStructureMarkingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markingFirstColour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "markingSecondColour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "mobile",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frangible",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "visibleMaterial",
              "_type": "aixm:CodeVerticalStructureMaterialType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lighting",
              "_type": "aixm:LightElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "horizontalProjection_surfaceExtent",
                "_type": "aixm:ElevatedSurfacePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "horizontalProjection_linearExtent",
                "_type": "aixm:ElevatedCurvePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "horizontalProjection_location",
                "_type": "aixm:ElevatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "VerticalStructurePartPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:CodeOrganisationDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeOrganisationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "military",
              "_type": "aixm:CodeMilitaryOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "contact",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "relatedOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityAssociationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "OrganisationAuthorityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeOrganisationHierarchyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theOrganisationAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "OrganisationAuthorityAssociationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeUnitType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "compliantICAO",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designator",
              "_type": "aixm:CodeOrganisationDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "military",
              "_type": "aixm:CodeMilitaryOperationsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "position",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "airportLocation",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "ownerOrganisation",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "contact",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "relatedUnit",
              "_type": "aixm:UnitDependencyPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:UnitAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "UnitPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operationalStatus",
            "_type": "aixm:CodeStatusOperationsType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "UnitAvailabilityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeUnitDependencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theUnit",
              "_type": "aixm:UnitPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "UnitDependencyPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "measurementPoint",
              "_type": "aixm:CodeProcedureDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApproachAltitudeTablePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "finalApproachPath",
              "_type": "aixm:CodeMinimaFinalApproachPathType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "requiredNavigationPerformance",
              "_type": "aixm:CodeRNPType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "climbGradient",
              "_type": "aixm:ValSlopeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumSet",
              "_type": "aixm:MinimaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "circlingRestriction",
              "_type": "aixm:CirclingRestrictionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "aircraftCategory",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "landingArea",
              "_type": "aixm:LandingTakeoffAreaCollectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "altimeter",
              "_type": "aixm:AltimeterSourcePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "designSurface",
              "_type": "aixm:ObstacleAssessmentAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApproachConditionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "startingMeasurementPoint",
              "_type": "aixm:CodeProcedureDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "valueHAT",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endingMeasurementPoint",
              "_type": "aixm:CodeProcedureDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApproachDistanceTablePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "startingMeasurementPoint",
              "_type": "aixm:CodeProcedureDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endingMeasurementPoint",
              "_type": "aixm:CodeProcedureDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "time",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speed",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ApproachTimingTablePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "altitude",
              "_type": "aixm:ApproachAltitudeTablePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "distance",
              "_type": "aixm:ApproachDistanceTablePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "timing",
              "_type": "aixm:ApproachTimingTablePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FinalProfilePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ProcedurePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "approachPrefix",
              "_type": "aixm:CodeApproachPrefixType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "approachType",
              "_type": "aixm:CodeApproachType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "multipleIdentification",
              "_type": "aixm:CodeUpperAlphaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "copterTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "circlingIdentification",
              "_type": "aixm:CodeUpperAlphaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseReversalInstruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "additionalEquipment",
              "_type": "aixm:CodeApproachEquipmentAdditionalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "channelGNSS",
              "_type": "aixm:ValChannelNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "WAASReliable",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "landing",
              "_type": "aixm:LandingTakeoffAreaCollectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "missedInstruction",
              "_type": "aixm:MissedApproachGroupPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "finalProfile",
              "_type": "aixm:FinalProfilePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "InstrumentApproachProcedurePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "alternateClimbInstruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "alternateClimbAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altimeter",
              "_type": "aixm:AltimeterSourcePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "MissedApproachGroupPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "arrivalAreaType",
              "_type": "aixm:CodeTAAType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "outerBufferWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lateralBufferWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "buffer",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "sector",
              "_type": "aixm:TerminalArrivalAreaSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "approachRNAV",
              "_type": "aixm:InstrumentApproachProcedurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": [
            {
              "element": [
                {
                  "_name": "IF_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IF_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IF_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IF_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IF_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IF_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            },
            {
              "element": [
                {
                  "_name": "IAF_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IAF_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IAF_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IAF_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IAF_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "IAF_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            }
          ]
        },
        "_name": "TerminalArrivalAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "flyByCode",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "procedureTurnRequired",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeDescription",
              "_type": "aixm:CodeAltitudeUseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "sectorDefinition",
              "_type": "aixm:CircleSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "extent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "significantObstacle",
              "_type": "aixm:ObstructionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "TerminalArrivalAreaSectorPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "horizontalAlarmLimit",
              "_type": "aixm:ValAlarmLimitType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalAlarmLimit",
              "_type": "aixm:ValAlarmLimitType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "thresholdCourseWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lengthOffset",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "CRCRemainder",
              "_type": "aixm:ValHexType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "operationType",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "serviceProviderSBAS",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "approachPerformanceDesignator",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "routeIndicator",
              "_type": "aixm:CodeRouteIndicatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "referencePathDataSelector",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "referencePathIdentifier",
              "_type": "aixm:CodeReferencePathIdentifierType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "codeICAO",
              "_type": "aixm:CodeICAOCountryType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FASDataBlockPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "extent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "approach",
              "_type": "aixm:InstrumentApproachProcedurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "condition",
              "_type": "aixm:ApproachConditionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "aircraftCategory",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "designSurface",
              "_type": "aixm:ObstacleAssessmentAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "CirclingAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "sectorDescription",
              "_type": "aixm:CircleSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "restrictionArea",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "CirclingRestrictionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeEquipmentUnavailableType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "approachLightingInoperative",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "adjustmentINOPCol",
              "_type": "aixm:EquipmentUnavailableAdjustmentColumnPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "EquipmentUnavailableAdjustmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "guidanceEquipment",
              "_type": "aixm:CodeApproachType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "landingSystemLights",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "equipmentRVR",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "visibilityAdjustment",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "approachLightingInoperative",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "EquipmentUnavailableAdjustmentColumnPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "altitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeCode",
              "_type": "aixm:CodeMinimumAltitudeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "height",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "militaryHeight",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "radioHeight",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "heightCode",
              "_type": "aixm:CodeMinimumHeightType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "heightReference",
              "_type": "aixm:CodeHeightReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "visibility",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "militaryVisibility",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "mandatoryRVR",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "remoteAltimeterMinima",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "adjustmentINOP",
              "_type": "aixm:EquipmentUnavailableAdjustmentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "MinimaPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ProcedurePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextSIDSTARDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "arrival",
              "_type": "aixm:LandingTakeoffAreaCollectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "StandardInstrumentArrivalPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "minimumEnrouteAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumCrossingAtEnd",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumCrossingAtEndReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maximumCrossingAtEnd",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maximumCrossingAtEndReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "engineType",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "DepartureArrivalConditionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "navigationAreaType",
              "_type": "aixm:CodeNavigationAreaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumCeiling",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumVisibility",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "departure",
              "_type": "aixm:StandardInstrumentDeparturePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "sector",
              "_type": "aixm:NavigationAreaSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "centrePoint_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "NavigationAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "sectorDefinition",
              "_type": "aixm:CircleSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "significantObstacle",
              "_type": "aixm:ObstructionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "extent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "sectorCriteria",
              "_type": "aixm:SectorDesignPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NavigationAreaSectorPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "turnDirection",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designGradient",
              "_type": "aixm:ValSlopeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "terminationAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turnPermitted",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SectorDesignPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ProcedurePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:TextSIDSTARDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "contingencyRoute",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "takeoff",
              "_type": "aixm:LandingTakeoffAreaCollectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "StandardInstrumentDeparturePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "safeAreaType",
              "_type": "aixm:CodeSafeAltitudeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "sector",
              "_type": "aixm:SafeAltitudeAreaSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "location",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "centrePoint_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "centrePoint_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "SafeAltitudeAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "bufferWidth",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "extent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "significantObstacle",
              "_type": "aixm:ObstructionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "sectorDefinition",
              "_type": "aixm:CircleSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SafeAltitudeAreaSectorPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:SegmentLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "approach",
            "_type": "aixm:InstrumentApproachProcedurePropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "1"
          }
        },
        "_name": "ApproachLegPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ApproachLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "requiredNavigationPerformance",
            "_type": "aixm:CodeRNPType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "ArrivalFeederLegPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:SegmentLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "requiredNavigationPerformance",
              "_type": "aixm:CodeRNPType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "arrival",
              "_type": "aixm:StandardInstrumentArrivalPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "ArrivalLegPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:SegmentLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "requiredNavigationPerformance",
              "_type": "aixm:CodeRNPType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumObstacleClearanceAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "departure",
              "_type": "aixm:StandardInstrumentDeparturePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "condition",
              "_type": "aixm:DepartureArrivalConditionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "DepartureLegPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ApproachLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "guidanceSystem",
              "_type": "aixm:CodeFinalGuidanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "landingSystemCategory",
              "_type": "aixm:CodeApproachGuidanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumBaroVnavTemperature",
              "_type": "aixm:ValTemperatureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rnpDMEAuthorized",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseOffsetAngle",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseOffsetSide",
              "_type": "aixm:CodeSideType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseCentrelineDistance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseOffsetDistance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseCentrelineIntersect",
              "_type": "aixm:CodeRelativePositionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "condition",
              "_type": "aixm:ApproachConditionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "visualDescentPoint",
              "_type": "aixm:TerminalSegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "FASData",
              "_type": "aixm:FASDataBlockPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "finalPathAlignmentPoint_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "finalPathAlignmentPoint_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "finalPathAlignmentPoint_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "finalPathAlignmentPoint_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "finalPathAlignmentPoint_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "finalPathAlignmentPoint_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "FinalLegPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "holdingUse",
              "_type": "aixm:CodeHoldingUseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instructedAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instructionAltitudeReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theHoldingPattern",
              "_type": "aixm:HoldingPatternPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "HoldingUsePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ApproachLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "requiredNavigationPerformance",
            "_type": "aixm:CodeRNPType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "InitialLegPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ApproachLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "requiredNavigationPerformance",
            "_type": "aixm:CodeRNPType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "IntermediateLegPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "runway",
              "_type": "aixm:RunwayDirectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "TLOF",
              "_type": "aixm:TouchDownLiftOffPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "LandingTakeoffAreaCollectionPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ApproachLegPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeMissedApproachType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "thresholdAfterMAPT",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "heightMAPT",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "requiredNavigationPerformance",
              "_type": "aixm:CodeRNPType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "condition",
              "_type": "aixm:ApproachConditionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "MissedApproachLegPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeNavigationAreaRestrictionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "procedure",
              "_type": "aixm:ProcedurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "designSurface",
              "_type": "aixm:ObstacleAssessmentAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "sectorDefinition",
              "_type": "aixm:CircleSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NavigationAreaRestrictionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "communicationFailureInstruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designCriteria",
              "_type": "aixm:CodeDesignStandardType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "codingStandard",
              "_type": "aixm:CodeProcedureCodingStandardType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flightChecked",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "RNAV",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "availability",
              "_type": "aixm:ProcedureAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "airportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "aircraftCharacteristic",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "flightTransition",
              "_type": "aixm:ProcedureTransitionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "safeAltitude",
              "_type": "aixm:SafeAltitudeAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "guidanceFacility_specialNavigationSystem",
                "_type": "aixm:SpecialNavigationSystemPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "guidanceFacility_radar",
                "_type": "aixm:RadarSystemPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "guidanceFacility_navaid",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "ProcedurePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "criticalDME",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "satisfactory",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "DME",
              "_type": "aixm:DMEPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "segmentLeg",
              "_type": "aixm:SegmentLegPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ProcedureDMEPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "transitionId",
              "_type": "aixm:CodeDesignatedPointDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeProcedurePhaseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "vectorHeading",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "departureRunwayTransition",
              "_type": "aixm:LandingTakeoffAreaCollectionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "trajectory",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "transitionLeg",
              "_type": "aixm:ProcedureTransitionLegPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ProcedureTransitionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "seqNumberARINC",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theSegmentLeg",
              "_type": "aixm:SegmentLegPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "ProcedureTransitionLegPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "endConditionDesignator",
              "_type": "aixm:CodeSegmentTerminationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "legPath",
              "_type": "aixm:CodeTrajectoryType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "legTypeARINC",
              "_type": "aixm:CodeSegmentPathType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "course",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseType",
              "_type": "aixm:CodeCourseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "courseDirection",
              "_type": "aixm:CodeDirectionReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turnDirection",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedLimit",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedReference",
              "_type": "aixm:CodeSpeedReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedInterpretation",
              "_type": "aixm:CodeAltitudeUseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "bankAngle",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "duration",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "procedureTurnRequired",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeInterpretation",
              "_type": "aixm:CodeAltitudeUseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeOverrideATC",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeOverrideReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalAngle",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "startPoint",
              "_type": "aixm:TerminalSegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "endPoint",
              "_type": "aixm:TerminalSegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "trajectory",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "arcCentre",
              "_type": "aixm:TerminalSegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "angle",
              "_type": "aixm:AngleIndicationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "distance",
              "_type": "aixm:DistanceIndicationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "aircraftCategory",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "holding",
              "_type": "aixm:HoldingUsePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "designSurface",
              "_type": "aixm:ObstacleAssessmentAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SegmentLegPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "status",
            "_type": "aixm:CodeProcedureAvailabilityType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "ProcedureAvailabilityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "distance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "applicableRoutePortion",
              "_type": "aixm:RoutePortionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "location_fixDesignatedPoint",
                "_type": "aixm:DesignatedPointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_navaidSystem",
                "_type": "aixm:NavaidPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_position",
                "_type": "aixm:PointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_runwayPoint",
                "_type": "aixm:RunwayCentrelinePointPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_aimingPoint",
                "_type": "aixm:TouchDownLiftOffPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "location_airportReferencePoint",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "ChangeOverPointPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designatorPrefix",
              "_type": "aixm:CodeRouteDesignatorPrefixType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorSecondLetter",
              "_type": "aixm:CodeRouteDesignatorLetterType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorNumber",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "multipleIdentifier",
              "_type": "aixm:CodeUpperAlphaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "locationDesignator",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeRouteType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flightRule",
              "_type": "aixm:CodeFlightRuleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "internationalUse",
              "_type": "aixm:CodeRouteOriginType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "militaryUse",
              "_type": "aixm:CodeMilitaryStatusType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "militaryTrainingType",
              "_type": "aixm:CodeMilitaryTrainingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "userOrganisation",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RoutePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "direction",
              "_type": "aixm:CodeDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "cardinalDirection",
              "_type": "aixm:CodeCardinalDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeRouteAvailabilityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "levels",
              "_type": "aixm:AirspaceLayerPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RouteAvailabilityPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "criticalDME",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "satisfactory",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "referencedDME",
              "_type": "aixm:DMEPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "applicableRoutePortion",
              "_type": "aixm:RoutePortionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RouteDMEPropertyGroup"
      },
      {
        "sequence": {
          "choice": [
            {
              "element": [
                {
                  "_name": "start_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            },
            {
              "element": [
                {
                  "_name": "intermediatePoint_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "intermediatePoint_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "intermediatePoint_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "intermediatePoint_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "intermediatePoint_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "intermediatePoint_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            },
            {
              "element": [
                {
                  "_name": "end_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            }
          ],
          "element": [
            {
              "_name": "referencedRoute",
              "_type": "aixm:RoutePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RoutePortionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "level",
              "_type": "aixm:CodeLevelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumObstacleClearanceAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "pathType",
              "_type": "aixm:CodeRouteSegmentPathType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trueTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "reverseTrueTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "reverseMagneticTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "length",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthLeft",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "widthRight",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turnDirection",
              "_type": "aixm:CodeDirectionTurnType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "signalGap",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumEnrouteAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumCrossingAtEnd",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumCrossingAtEndReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maximumCrossingAtEnd",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "maximumCrossingAtEndReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "navigationType",
              "_type": "aixm:CodeRouteNavigationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "requiredNavigationPerformance",
              "_type": "aixm:CodeRNPType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "designatorSuffix",
              "_type": "aixm:CodeRouteDesignatorSuffixType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "start",
              "_type": "aixm:EnRouteSegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "routeFormed",
              "_type": "aixm:RoutePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "evaluationArea",
              "_type": "aixm:ObstacleAssessmentAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "curveExtent",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "end",
              "_type": "aixm:EnRouteSegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "availability",
              "_type": "aixm:RouteAvailabilityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RouteSegmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "exitedAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "enteredAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirspaceBorderCrossingPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "annotation",
            "_type": "aixm:NotePropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "unbounded"
          }
        },
        "_name": "DirectFlightPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "exceedLength",
            "_type": "aixm:ValDistanceType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "DirectFlightClassPropertyGroup"
      },
      {
        "sequence": {
          "choice": [
            {
              "element": [
                {
                  "_name": "end_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "end_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            },
            {
              "element": [
                {
                  "_name": "start_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "start_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            }
          ]
        },
        "_name": "DirectFlightSegmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "referenceLocation",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "relationWithLocation",
              "_type": "aixm:CodeLocationQualifierType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FlightConditionCircumstancePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "logicalOperator",
              "_type": "aixm:CodeFlowConditionOperationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "element",
              "_type": "aixm:FlightConditionElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FlightConditionCombinationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "index",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "operationalCondition",
              "_type": "aixm:FlightConditionCircumstancePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "flightLevel",
              "_type": "aixm:FlightRestrictionLevelPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "flightCondition_weather",
                "_type": "aixm:MeteorologyPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_aircraft",
                "_type": "aixm:AircraftCharacteristicPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_flight",
                "_type": "aixm:FlightCharacteristicPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_directFlightCondition",
                "_type": "aixm:DirectFlightPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_borderCrossingCondition",
                "_type": "aixm:AirspaceBorderCrossingPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_operand",
                "_type": "aixm:FlightConditionCombinationPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_routePortionCondition",
                "_type": "aixm:RoutePortionPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_standardInstrumentDepartureCondition",
                "_type": "aixm:StandardInstrumentDeparturePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_standardInstrumentArrivalCondition",
                "_type": "aixm:StandardInstrumentArrivalPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_organisationCondition",
                "_type": "aixm:OrganisationAuthorityPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_airspaceCondition",
                "_type": "aixm:AirspacePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_airportHeliportCondition",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "flightCondition_aerialRefuellingCondition",
                "_type": "aixm:AerialRefuellingPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ],
            "choice": {
              "element": [
                {
                  "_name": "significantPointCondition_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "significantPointCondition_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "significantPointCondition_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "significantPointCondition_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "significantPointCondition_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "significantPointCondition_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            }
          }
        },
        "_name": "FlightConditionElementPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "designator",
              "_type": "aixm:CodeFlightRestrictionDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeFlightRestrictionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "instruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flight",
              "_type": "aixm:FlightConditionCombinationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "regulatedRoute",
              "_type": "aixm:FlightRestrictionRoutePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FlightRestrictionPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "upperLevel",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLevelReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLevel",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLevelReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FlightRestrictionLevelPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "priorPermission",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "routeElement",
              "_type": "aixm:FlightRoutingElementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "contact",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FlightRestrictionRoutePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "orderNumber",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speed",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedReference",
              "_type": "aixm:CodeSpeedReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedCriteria",
              "_type": "aixm:CodeComparisonType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flightLevel",
              "_type": "aixm:FlightRestrictionLevelPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "element_directFlightElement",
                "_type": "aixm:DirectFlightSegmentPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "element_routePortionElement",
                "_type": "aixm:RoutePortionPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "element_standardInstrumentDepartureElement",
                "_type": "aixm:StandardInstrumentDeparturePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "element_standardInstrumentArrivalElement",
                "_type": "aixm:StandardInstrumentArrivalPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "element_airspaceElement",
                "_type": "aixm:AirspacePropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "element_airportHeliportElement",
                "_type": "aixm:AirportHeliportPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "element_aerialRefuellingElement",
                "_type": "aixm:AerialRefuellingPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ],
            "choice": {
              "element": [
                {
                  "_name": "pointElement_fixDesignatedPoint",
                  "_type": "aixm:DesignatedPointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "pointElement_navaidSystem",
                  "_type": "aixm:NavaidPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "pointElement_position",
                  "_type": "aixm:PointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "pointElement_runwayPoint",
                  "_type": "aixm:RunwayCentrelinePointPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "pointElement_aimingPoint",
                  "_type": "aixm:TouchDownLiftOffPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                },
                {
                  "_name": "pointElement_airportReferencePoint",
                  "_type": "aixm:AirportHeliportPropertyType",
                  "_nillable": "true",
                  "_minOccurs": "0"
                }
              ]
            }
          }
        },
        "_name": "FlightRoutingElementPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "category",
              "_type": "aixm:CodeRuleProcedureType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "title",
              "_type": "aixm:CodeRuleProcedureTitleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "content",
              "_type": "aixm:XHTMLType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "affectedLocation",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "affectedArea",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RulesProceduresPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportGroundServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "type",
            "_type": "aixm:CodeAircraftGroundServiceType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "AircraftGroundServicePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportGroundServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "snowPlan",
            "_type": "aixm:TextInstructionType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "AirportClearanceServicePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "airportHeliport",
            "_type": "aixm:AirportHeliportPropertyType",
            "_nillable": "true",
            "_minOccurs": "0",
            "_maxOccurs": "unbounded"
          }
        },
        "_name": "AirportGroundServicePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportGroundServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "fuelSupply",
              "_type": "aixm:FuelPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "oilSupply",
              "_type": "aixm:OilPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "nitrogenSupply",
              "_type": "aixm:NitrogenPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "oxygenSupply",
              "_type": "aixm:OxygenPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirportSuppliesServicePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:TrafficSeparationServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeServiceATCType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clientAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientRoute",
              "_type": "aixm:RoutePortionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientProcedure",
              "_type": "aixm:ProcedurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientHolding",
              "_type": "aixm:HoldingPatternPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientAerialRefuelling",
              "_type": "aixm:AerialRefuellingPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "aircraftLocator",
              "_type": "aixm:DirectionFinderPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "AirTrafficControlServicePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeServiceATFMType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clientAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientAerialRefuelling",
              "_type": "aixm:AerialRefuellingPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientRoute",
              "_type": "aixm:RoutePortionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirTrafficManagementServicePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "callSign",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "language",
              "_type": "aixm:CodeLanguageType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "CallsignDetailPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportGroundServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "category",
              "_type": "aixm:CodeFireFightingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "standard",
              "_type": "aixm:CodeAviationStandardsType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "FireFightingServicePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "category",
              "_type": "aixm:CodeFuelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FuelPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:TrafficSeparationServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeServiceGroundControlType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clientAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "GroundTrafficControlServicePropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeServiceInformationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "voice",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dataLink",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "recorded",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "navaidBroadcast",
              "_type": "aixm:VORPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientAirport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientRoute",
              "_type": "aixm:RoutePortionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientProcedure",
              "_type": "aixm:ProcedurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientHolding",
              "_type": "aixm:HoldingPatternPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientAerialRefuelling",
              "_type": "aixm:AerialRefuellingPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "InformationServicePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeNitrogenType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "NitrogenPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "category",
              "_type": "aixm:CodeOilType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "OilPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeOxygenType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "OxygenPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:AirportGroundServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "type",
            "_type": "aixm:CodePassengerServiceType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "PassengerServicePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodePilotControlledLightingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "duration",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "intensitySteps",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "standByIntensity",
              "_type": "aixm:CodeIntensityStandByType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "radioFrequency",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "activationInstruction",
              "_type": "aixm:TextInstructionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "controlledLightIntensity",
              "_type": "aixm:LightActivationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "activatedGroundLighting",
              "_type": "aixm:GroundLightSystemPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "PilotControlledLightingPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "mode",
              "_type": "aixm:CodeCommunicationModeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rank",
              "_type": "aixm:CodeFacilityRankingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frequencyTransmission",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "frequencyReception",
              "_type": "aixm:ValFrequencyType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "channel",
              "_type": "aixm:CodeCommunicationChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "logon",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "emissionType",
              "_type": "aixm:CodeRadioEmissionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "selectiveCall",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "flightChecked",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "trafficDirection",
              "_type": "aixm:CodeCommunicationDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:RadioCommunicationOperationalStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RadioCommunicationChannelPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operationalStatus",
            "_type": "aixm:CodeStatusServiceType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "RadioCommunicationOperationalStatusPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeServiceSARType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "clientAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "clientRoute",
              "_type": "aixm:RoutePortionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SearchRescueServicePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "flightOperations",
              "_type": "aixm:CodeFlightDestinationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rank",
              "_type": "aixm:CodeFacilityRankingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "compliantICAO",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "serviceProvider",
              "_type": "aixm:UnitPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "call-sign",
              "_type": "aixm:CallsignDetailPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "radioCommunication",
              "_type": "aixm:RadioCommunicationChannelPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "groundCommunication",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:ServiceOperationalStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ServicePropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "operationalStatus",
            "_type": "aixm:CodeStatusServiceType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "ServiceOperationalStatusPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:ServicePropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "radarAssisted",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dataLinkEnabled",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dataLinkChannel",
              "_type": "aixm:CodeCommunicationChannelType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "TrafficSeparationServicePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "title",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "address",
              "_type": "aixm:PostalAddressPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "networkNode",
              "_type": "aixm:OnlineContactPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "phoneFax",
              "_type": "aixm:TelephoneContactPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ContactInformationPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "network",
              "_type": "aixm:CodeTelecomNetworkType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "linkage",
              "_type": "aixm:TextAddressType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "protocol",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "eMail",
              "_type": "aixm:TextAddressType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "OnlineContactPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "deliveryPoint",
              "_type": "aixm:TextAddressType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "city",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "administrativeArea",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "postalCode",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "country",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "PostalAddressPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "voice",
              "_type": "aixm:TextPhoneType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "facsimile",
              "_type": "aixm:TextPhoneType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "TelephoneContactPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeAircraftType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "engine",
              "_type": "aixm:CodeAircraftEngineType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "numberEngine",
              "_type": "aixm:CodeAircraftEngineNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "typeAircraftICAO",
              "_type": "aixm:CodeAircraftICAOType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "aircraftLandingCategory",
              "_type": "aixm:CodeAircraftCategoryType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "wingSpan",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "wingSpanInterpretation",
              "_type": "aixm:CodeValueInterpretationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "classWingSpan",
              "_type": "aixm:CodeAircraftWingspanClassType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "weight",
              "_type": "aixm:ValWeightType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "weightInterpretation",
              "_type": "aixm:CodeValueInterpretationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "passengers",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "passengersInterpretation",
              "_type": "aixm:CodeValueInterpretationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speed",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedInterpretation",
              "_type": "aixm:CodeValueInterpretationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "wakeTurbulence",
              "_type": "aixm:CodeWakeTurbulenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "navigationEquipment",
              "_type": "aixm:CodeNavigationEquipmentType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "navigationSpecification",
              "_type": "aixm:CodeNavigationSpecificationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalSeparationCapability",
              "_type": "aixm:CodeRVSMType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "antiCollisionAndSeparationEquipment",
              "_type": "aixm:CodeEquipmentAntiCollisionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "communicationEquipment",
              "_type": "aixm:CodeCommunicationModeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surveillanceEquipment",
              "_type": "aixm:CodeTransponderType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AircraftCharacteristicPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeFlightType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rule",
              "_type": "aixm:CodeFlightRuleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "status",
              "_type": "aixm:CodeFlightStatusType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "military",
              "_type": "aixm:CodeMilitaryStatusType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "origin",
              "_type": "aixm:CodeFlightOriginType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "purpose",
              "_type": "aixm:CodeFlightPurposeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "FlightCharacteristicPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeInterpretation",
              "_type": "aixm:CodeAltitudeUseType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "discreteLevelSeries",
              "_type": "aixm:StandardLevelColumnPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AirspaceLayerPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "arcDirection",
              "_type": "aixm:CodeArcDirectionType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "fromAngle",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "toAngle",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleType",
              "_type": "aixm:CodeBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleDirectionReference",
              "_type": "aixm:CodeDirectionReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "innerDistance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "outerDistance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "CircleSectorPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "colour",
              "_type": "aixm:CodeColourType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "intensityLevel",
              "_type": "aixm:CodeLightIntensityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "intensity",
              "_type": "aixm:ValLightIntensityType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "type",
              "_type": "aixm:CodeLightSourceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "availability",
              "_type": "aixm:LightElementStatusPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "LightElementPropertyGroup"
      },
      {
        "sequence": {
          "element": {
            "_name": "status",
            "_type": "aixm:CodeStatusOperationsType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "LightElementStatusPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "flightConditions",
              "_type": "aixm:CodeMeteoConditionsType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "visibility",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "visibilityInterpretation",
              "_type": "aixm:CodeValueInterpretationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "runwayVisualRange",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "runwayVisualRangeInterpretation",
              "_type": "aixm:CodeValueInterpretationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "MeteorologyPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeRadioFrequencyAreaType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleScallop",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "signalType",
              "_type": "aixm:CodeRadioSignalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "sector",
              "_type": "aixm:CircleSectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "extent",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ],
          "choice": {
            "element": [
              {
                "_name": "equipment_radar",
                "_type": "aixm:SecondarySurveillanceRadarPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "equipment_precisionApproachRadar",
                "_type": "aixm:PrecisionApproachRadarPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "equipment_frequency",
                "_type": "aixm:RadioCommunicationChannelPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "equipment_specialNavigationStation",
                "_type": "aixm:SpecialNavigationStationPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              },
              {
                "_name": "equipment_navaidEquipment",
                "_type": "aixm:NavaidEquipmentPropertyType",
                "_nillable": "true",
                "_minOccurs": "0"
              }
            ]
          }
        },
        "_name": "RadioFrequencyAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "timeInterval",
              "_type": "aixm:TimesheetPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "specialDateAuthority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "PropertiesWithSchedulePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeSpecialDateType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dateDay",
              "_type": "aixm:DateMonthDayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dateYear",
              "_type": "aixm:DateYearType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "authority",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            }
          ]
        },
        "_name": "SpecialDatePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "timeReference",
              "_type": "aixm:CodeTimeReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "startDate",
              "_type": "aixm:DateMonthDayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endDate",
              "_type": "aixm:DateMonthDayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "day",
              "_type": "aixm:CodeDayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dayTil",
              "_type": "aixm:CodeDayType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "startTime",
              "_type": "aixm:TimeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "startEvent",
              "_type": "aixm:CodeTimeEventType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "startTimeRelativeEvent",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "startEventInterpretation",
              "_type": "aixm:CodeTimeEventCombinationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endTime",
              "_type": "aixm:TimeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endEvent",
              "_type": "aixm:CodeTimeEventType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endTimeRelativeEvent",
              "_type": "aixm:ValDurationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "endEventInterpretation",
              "_type": "aixm:CodeTimeEventCombinationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "daylightSavingAdjust",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "excluded",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "TimesheetPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "verticalDistance",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "StandardLevelPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "series",
              "_type": "aixm:CodeLevelSeriesType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "unitOfMeasurement",
              "_type": "aixm:CodeDistanceVerticalUomType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "separation",
              "_type": "aixm:CodeRVSMType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "level",
              "_type": "aixm:StandardLevelPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "levelTable",
              "_type": "aixm:StandardLevelTablePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "StandardLevelColumnPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "flightRule",
              "_type": "aixm:CodeFlightRuleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "fromTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "toTrack",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "angleType",
              "_type": "aixm:CodeNorthReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "applicableAirspace",
              "_type": "aixm:AirspacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "applicableLevelColumn",
              "_type": "aixm:StandardLevelColumnPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "StandardLevelSectorPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:CodeLevelTableDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "standardICAO",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "StandardLevelTablePropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "altitudeAdjustmentType",
              "_type": "aixm:CodeAltitudeAdjustmentType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "primaryAlternateMinimum",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "altitudeAdjustment",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "localRemoteCode",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "AltitudeAdjustmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "upperLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "upperLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimit",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "lowerLimitReference",
              "_type": "aixm:CodeVerticalReferenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "speedLimit",
              "_type": "aixm:ValSpeedType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "patternTemplate",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "turbulentAir",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "legLengthToward",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "legLengthAway",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "holdingPoint",
              "_type": "aixm:SegmentPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "unplannedHolding",
              "_type": "aixm:UnplannedHoldingPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "assessedHoldingPattern",
              "_type": "aixm:HoldingPatternPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "obstacleAssessment",
              "_type": "aixm:ObstacleAssessmentAreaPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "HoldingAssessmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeObstacleAssessmentSurfaceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "sectionNumber",
              "_type": "aixm:NoNumberType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slope",
              "_type": "aixm:ValSlopeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "assessedAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slopeLowerAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "gradientLowHigh",
              "_type": "aixm:ValSlopeType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfaceZone",
              "_type": "aixm:CodeObstructionIdSurfaceZoneType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "safetyRegulation",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "aircraftCategory",
              "_type": "aixm:AircraftCharacteristicPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "significantObstacle",
              "_type": "aixm:ObstructionPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "surface",
              "_type": "aixm:SurfacePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "startingCurve",
              "_type": "aixm:CurvePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ObstacleAssessmentAreaPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "obstacleBearing",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "obstacleDistance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "pointType",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "obstaclePlacement",
              "_type": "aixm:CodeSideType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ObstaclePlacementPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "requiredClearance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "minimumAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "surfacePenetration",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slopePenetration",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "controlling",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "closeIn",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "theVerticalStructure",
              "_type": "aixm:VerticalStructurePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "adjustment",
              "_type": "aixm:AltitudeAdjustmentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "obstaclePlacement",
              "_type": "aixm:ObstaclePlacementPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ObstructionPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:RadarEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "precisionApproachRadarType",
              "_type": "aixm:CodePARType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slope",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "slopeAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "reflector",
              "_type": "aixm:ReflectorPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "PrecisionApproachRadarPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:SurveillanceRadarPropertyGroup",
            "_minOccurs": "0"
          },
          "element": {
            "_name": "type",
            "_type": "aixm:CodePrimaryRadarType",
            "_nillable": "true",
            "_minOccurs": "0"
          }
        },
        "_name": "PrimarySurveillanceRadarPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "collocationGroup",
              "_type": "aixm:NoSequenceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theRadarEquipment",
              "_type": "aixm:RadarEquipmentPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "RadarComponentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "name",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "serialNumber",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "range",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "rangeAccuracy",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dualChannel",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "movingTargetIndicator",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "standbyPower",
              "_type": "aixm:CodeStandbyPowerType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "digital",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "militaryUseOnly",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "specialUseOnly",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "specialAircraftOnly",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariation",
              "_type": "aixm:ValMagneticVariationType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "magneticVariationAccuracy",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "dateMagneticVariation",
              "_type": "aixm:DateYearType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "contact",
              "_type": "aixm:ContactInformationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RadarEquipmentPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeRadarServiceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "model",
              "_type": "aixm:TextNameType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "generalTerrainMonitor",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "broadcastIdentifier",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "radarEquipment",
              "_type": "aixm:RadarComponentPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "office",
              "_type": "aixm:OrganisationAuthorityPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "airportHeliport",
              "_type": "aixm:AirportHeliportPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "PARRunway",
              "_type": "aixm:RunwayPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "location",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "RadarSystemPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "type",
              "_type": "aixm:CodeReflectorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "touchdownReflector",
              "_type": "aixm:ElevatedPointPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "1"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "ReflectorPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:SurveillanceRadarPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "transponder",
              "_type": "aixm:CodeTransponderType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "autonomous",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "monopulse",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "SecondarySurveillanceRadarPropertyGroup"
      },
      {
        "sequence": {
          "element": [
            {
              "_name": "videoMap",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "annotation",
              "_type": "aixm:NotePropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            },
            {
              "_name": "theUnit",
              "_type": "aixm:UnitPropertyType",
              "_minOccurs": "0"
            }
          ]
        },
        "_name": "SurveillanceGroundStationPropertyGroup"
      },
      {
        "sequence": {
          "group": {
            "_ref": "aixm:RadarEquipmentPropertyGroup",
            "_minOccurs": "0"
          },
          "element": [
            {
              "_name": "verticalCoverageAltitude",
              "_type": "aixm:ValDistanceVerticalType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalCoverageDistance",
              "_type": "aixm:ValDistanceType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "verticalCoverageAzimuth",
              "_type": "aixm:ValBearingType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "antennaTiltFixed",
              "_type": "aixm:CodeYesNoType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "tiltAngle",
              "_type": "aixm:ValAngleType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "automatedRadarTerminalSystem",
              "_type": "aixm:TextDesignatorType",
              "_nillable": "true",
              "_minOccurs": "0"
            },
            {
              "_name": "groundStation",
              "_type": "aixm:SurveillanceGroundStationPropertyType",
              "_nillable": "true",
              "_minOccurs": "0",
              "_maxOccurs": "unbounded"
            }
          ]
        },
        "_name": "SurveillanceRadarPropertyGroup"
      }
    ],
    "_xmlns": "http://www.w3.org/2001/XMLSchema",
    "_xmlns:aixm": "http://www.aixm.aero/schema/5.1.1",
    "_xmlns:gml": "http://www.opengis.net/gml/3.2",
    "_xmlns:xlink": "http://www.w3.org/1999/xlink",
    "_targetNamespace": "http://www.aixm.aero/schema/5.1.1",
    "_elementFormDefault": "qualified",
    "_attributeFormDefault": "unqualified",
    "_version": "5.1.1"
  }
}